export default {
    structuredData: {
        shippingCountry: 'CZ',
        addressCountry: 'CZ',
        addressRegion: 'Česká Republika',
    },
    xProducts: '-|{n} produkt|{n} produkty|{n} produktů',
    header: {
        locale: 'cs',
        currency: 'CZK',
        currencySymbol: 'Kč',
        pieces: 'ks',
        closed: 'zavřeno',
        credits: 'kreditů | kredit | kredity | kreditů',
        showText: 'Zobrazit více',
        hideText: 'Skrýt',
        detail: 'Detail',
        close: 'Zavřít',
        products: 'Produkty',
        download: 'Stáhnout',
        loading: 'Načítání',
        category: {
            title: 'Kategorie',
            bestSellers: 'Nejprodávanější produkty',
        },
        brands: 'Značky',
        addToCart: 'Do košíku',
        gift: 'Dárek',
        todayAction: 'Dnešní akční cena',
        of: 'z',
        from: 'od',
        url: {
            cartStep1: '/kosik',
            contact: '/kontakt',
            search: '/hledej',
            category: {
                sale: '/akce-a-slevy',
                saleAndDiscount: '/akce-a-slevy',
                onePlusOne: '/akce-a-slevy?vt[0]=8',
                twoPlusOne: '/akce-a-slevy?vt[0]=17',
            },
            static: {
                pilulkaClub: '/pilulka-klub',
            },
            user: {
                login: '/prihlasit-se',
                logout: '/backend/logout',
                profile: '/muj-ucet',
                orders: '/objednavky',
                feedback: '/hodnoceni',
                myFavorite: '/me-oblibene',
                forgottenPassword: '/zapomenute-heslo',
                registration: '/registrace',
            },
            counselling: '/poradna',
            pharmacies: '/pilulka-lekarny',
        },

        siteHeader: {
            logoTitle: 'Pilulka.cz - vaše online lékárna s více než 1247 odběrnými místy  po ČR',
            basket: 'Košík',
            category: 'Kategorie',
            chat: 'Chat',
            startChat: 'Spustit chat',
            search: {
                title: 'Vyhledat',
                placeholder: 'Hledejte na Pilulka.cz',
                notfound: 'Zkontrolujte prosím vyhledávané slovo.',
                lastVisitsProducts: 'Naposledy navštívené',
                label: 'Hledat',
                showXProducts: 'Zobrazit 0 produktů | Zobrazit 1 produkt | Zobrazit {n} produkty | Zobrazit {n} produktů',
                staticContents: 'Články',
                pharmacies: 'Lékárny',
                startSearch: 'Zadejte vyhledávané slovo.',
            },
            login: {
                incorrectLogin: 'Zadali jste špatný e-mail nebo heslo',
                email: 'Váš e-mail',
                password: 'Vaše heslo',
                showPassword: 'Zobrazit heslo',
                sendForgottenPassword: 'Zapomněl jsem heslo',
                title: 'Moje Pilulka',
                label: 'Přihlásit',
                loginAction: 'Přihlásit se',
                loginWithFacebook: 'Přihlásit přes Facebook',
                loginWithGoogle: 'Přihlásit přes Google',
                register: 'Registrovat se',
                favoriteAndRecentlyPurchasedProducts: 'Oblíbené a zakoupené produkty',
                myRatings: 'Moje hodnocení',
                favoriteProducts: 'Oblíbené produkty',
                reviewClub: 'Recenzní klub',
                userInfo: 'Osobní údaje',
                credits: '%{credits} kreditů',
                orders: 'Objednávky',
                ratings: 'Hodnocení produktu',
                myProfile: 'Můj profil',
                logout: 'Odhlásit se',
                google: 'Přihlásit přes Google',
            },
            cartBox: {
                basket: 'Košík',
                cart: 'Košík',
                goBasket: 'Přejít do košíku',
                greatYouAreGettingFreeDelivery: {
                    text: 'Skvělé! Získáváte',
                    uppercase: 'dopravu zdarma!',
                },
                greatYouAreGettingDiscountedDelivery: {
                    text: 'Skvělé! Získáváte',
                    uppercase: 'slevu na dopravu!',
                },
                youDoNotHaveANythingInYourBasketYet: 'Ve svém košíku zatím nic nemáte',
                checkOutOurPriceHits: 'Podívejte se na naše cenové trháky',
                buyMoreAndGetFreeDelivery1: 'Nakupte zboží ještě za ',
                buyMoreAndGetFreeDelivery2: ' a dopravu máte zdarma!',
                showAllProductsInTheCart: 'Zobrazit všechny produkty v košíku',
            },
            menu: {
                transport: 'Doprava',
                club: 'Pilulka klub',
                favorite: 'Mé oblíbené produkty',
            },
            allProducts: 'Zobrazit všechny produkty',
            searchResults: 'Výsledky vyhledávání',
            seeAllCategory: 'Zobrazit vše v kategorii',
            sale: {
                title: 'Akce a slevy',
                url: '/akce-a-slevy',
                more: 'Zobrazit všechny akce a slevy',
            },
            christmas: {
                title: 'Vánoce',
                url: '/darky',
            },
            moreCategories: 'Více kategorií',
            clinic: {
                url: '/pilulka-klinika?pwa=1',
                text: 'Klinika',
            },
            erecept: {
                url: 'https://erecept.pilulka.cz/',
                title: 'Léky na eRecept',
                text: 'eRecept',
            },
            blackFriday: {
                title: 'Black Friday',
                url: '/black-friday',
            },
            favorite: 'Oblíbené',
            counselling: 'Poradna',
            pharmacies: 'Lékárny',
            articles: {
                title: 'Články',
                url: '/clanky',
            },
            brands: {
                title: 'Značky',
                url: '/prehled-znacek',
                showAllBrands: 'Zobrazit všechny značky',
            },
        },
        searchTern: 'Hledané výrazy',
        notFound: 'Pro zadaný výraz se nám nic nepodařilo najít. Výraz smažte nebo upravte.',
        mobileApp: {
            title: 'Aplikace pro lepší život',
            banner: {
                title: 'Pilulka',
                text: 'Otevřít v aplikaci Pilulka',
                open: 'otevřít',
            },
            ios: {
                link: 'https://itunes.apple.com/us/app/pilulka-cz/id1287999800?l=cs&ls=1',
                alt: 'Stáhnout na App Store',
            },
            android: {
                link: 'intent://play.google.com/store/apps/details?id=cz.pilulka.shop&hl=cs/#Intent;package=cz.pilulka.shop;end',
                alt: 'Stáhnout na Google Play',
            },
            box: {
                title1: 'Sledujte kurýra Pilulka Expres',
                text1: 'Budete vědět přesně kdy vám balíček dorazí',
                title2: 'Odměňujeme vás za pohyb',
                text2: 'Za pravidelný pohyb od nás dostane kredity na nákup',
            },
            homepageBanner: {
                easierShoppingWithPilulkaApp: 'Jednodušší nakupování s aplikací Pilulka',
                quickAndRepeatedPurchaseViaOneClick: 'Rychlý opakovaný nákup na jeden klik',
                discountsAndBetterPricesInApp: 'Speciální ceny a akce v aplikaci',
                youKnowExactlyWhereYourOrderIs: 'Přesně víte, v jakém stavu a kde je vaše objednávka',
            },
        },
        guarantee: {
            default: 'Garantujeme doručení do Vánoc.',
            defaultLinkText: 'Zjistit více',
            defaultLink: '/garance-doruceni-do-vanoc',
            pilulkaExpress: 'Pilulka Expres',
            pilulkaExpressDate: 'Můžete objednat do 22. 12. do 21:00',
            pilulkaBox: 'Pilulka Boxy',
            pilulkaBoxDate: 'Můžete objednat do 22. 12. do 6:30',
        },
    },
    footerDictionary: {
        locale: 'cs',
        currency: 'CZK',
        currencySymbol: 'Kč',
        pieces: 'ks',
        closed: 'zavřeno',
        credits: 'kreditů | kredit | kredity | kreditů',
        showText: 'Zobrazit více',
        hideText: 'Skrýt',
        detail: 'Detail',
        close: 'Zavřít',
        products: 'Produkty',
        download: 'Stáhnout',
        loading: 'Načítání',
        category: {
            title: 'Kategorie',
            bestSellers: 'Nejprodávanější produkty',
        },
        brands: 'Značky',
        gift: 'Dárek',
        todayAction: 'Dnešní akční cena',
        of: 'z',
        url: {
            cartStep1: '/kosik',
            search: '/hledej',
            category: {
                sale: '/akce-a-slevy',
                saleAndDiscount: '/akce-a-slevy',
            },
            static: {
                pilulkaClub: '/pilulka-klub',
            },
            user: {
                login: '/prihlasit-se',
                logout: '/logout',
                profile: '/muj-ucet',
                orders: '/objednavky',
                feedback: '/objednavky',
                myFavorite: '/objednavky',
                forgottenPassword: '/zapomenute-heslo',
                registration: '/registrace',
            },
        },
        followUs: 'Sledujte nás\n',
        downloadApp: 'Stáhnout Pilulka Aplikaci',
        customerSupport: {
            phoneName: 'Telefon: ',
            phone: '+420 222 703 000',
            whatsAppName: 'WhatsApp: ',
            whatsApp: '+420 771 285 847',
            phoneAvailability: 'Po - Pá 8:00 - 18:00',
            email: 'dotazy@pilulka.cz',
            emailAvailability: '',
            chat: 'Provozní doba<br />zákaznické péče',
            chatAvailability: '',
            contact: '/kontakt',
            generalAvailability: '',
            weWillHelpYou: 'Poradíme vám',
            address: '',
            address_street: '',
        },
        sukl: {
            // footerSukl: {
            //    url: 'https://prehledy.sukl.cz/prehledy.html#/lekarny/00202865941',
            //    imagePath: 'https://www.pilulka.cz/images/jpg/cs/sukl.png?v=1564143904',
            //    alt: 'sukl',
            // },
            footerSukl1: {
                url: 'https://prehledy.sukl.cz/prehledy.html#/lekarny/00200820293',
                imagePath: 'https://www.pilulka.cz/images/jpg/cs/sukl.png?v=1679919013',
                alt: 'sukl',
            },
            footerUskvbl: {
                url: 'https://www.uskvbl.cz/cs/inspekce/lekarny/seznamy/detail?Id=00200820293',
                imagePath: 'https://www.pilulka.cz/images/jpg/cs/uskvbl.png?v=1662499363',
                alt: 'uskvbl',
            },
            // footerUskvbl1: {
            //     url: 'https://www.uskvbl.cz/cs/inspekce/lekarny/seznamy/detail?Id=202865941',
            //     imagePath: 'https://www.pilulka.cz/images/jpg/cs/uskvbl.png?v=1679919013',
            //     alt: 'uskvbl',
            // },
        },
        weRespondEveryWeekday: 'weRespondEveryWeekday',
        advantages: [
            {
                imageUrl: '/nuxt-assets/images/icons/usp/autoUsp.svg', // TODO change icons
                title: 'Pilulka Expres <br /> pohodlné doručení po městě',
                url: '/pilulka-expres',
            },
            {
                imageUrl: '/nuxt-assets/images/icons/usp/box.svg', // TODO change icons
                title: 'Vyzvednutí bez front a čekání <br /> ve Výdejních Boxech.',
                url: '/pilulka-box',
            },
            {
                imageUrl: '/nuxt-assets/images/icons/usp/location2.svg', // TODO change icons
                title: 'Přes 100 Pilulka Lékáren <br /> a dalších 5000+ odběrných míst',
                url: '/pilulka-lekarny',
            },
            {
                imageUrl: '/nuxt-assets/images/icons/usp/pharmacy.svg', // TODO change icons
                title: 'Nejspolehlivější <br /> internetová lékárna v ČR',
                url: '/proc-nakupovat-na-pilulka-cz',
            },
        ],
        linkSections: [
            // {
            //     title: 'Poradíme vám',
            //     links: [
            //         {
            //             url: '/nejcasteji-kladene-dotazy',
            //             isOutlink: true,
            //             title: 'Nejčastější dotazy zákazníků',
            //             class: 'fwb',
            //         },
            //         {
            //             url: '',
            //             isOutlink: true,
            //             title: 'Spustit chat se zákaznickou',
            //             class: 'fwb text-primary text-decoration-underline',
            //             openChat: true,
            //         },
            //         {
            //             url: '/kontakt',
            //             isOutlink: true,
            //             title: 'Kontakt na zákaznickou',
            //             class: 'fwb',
            //         },
            //     ],
            // },
            {
                title: 'Zákaznická podpora',
                links: [
                    {
                        url: 'https://www.pilulka.cz/kontakt',
                        isOutlink: true,
                        title: 'Kontakt',
                    },
                    {
                        url: 'https://www.pilulka.cz/nejcasteji-kladene-dotazy',
                        isOutlink: true,
                        title: 'Často kladené otázky',
                    },
                    {
                        url: 'https://www.pilulka.cz/moznosti-dopravy',
                        isOutlink: true,
                        title: 'Možnosti dopravy',
                    },
                    {
                        url: 'https://www.pilulka.cz/moznosti-platby',
                        isOutlink: true,
                        title: 'Možnosti platby',
                    },
                    {
                        url: 'https://www.pilulka.cz/reklamace-a-vraceni-zbozi',
                        isOutlink: true,
                        title: 'Reklamace a vrácení zboží',
                    },
                    // {
                    //     url: '/proc-nakupovat-na-pilulka-cz',
                    //     isOutlink: true,
                    //     title: 'Proč nakupovat na Pilulka.cz',
                    // },
                    // {
                    //     url: '/moznosti-dopravy',
                    //     isOutlink: true,
                    //     title: 'Možnosti dopravy',
                    // },
                    // {
                    //     url: '/moznosti-platby',
                    //     isOutlink: true,
                    //     title: 'Možnosti platby',
                    // },
                    // {
                    //     url: '/reklamace-a-vraceni-zbozi',
                    //     isOutlink: true,
                    //     title: 'Reklamace a vrácení zboží',
                    // },
                    // {
                    //     url: '/overeni-stavu-objednavky',
                    //     isOutlink: true,
                    //     title: 'Ověření stavu objednávky',
                    // },
                    // {
                    //     url: '/jak-uplatnit-kredity',
                    //     isOutlink: true,
                    //     title: 'Jak uplatnit kredity',
                    // },
                    // {
                    //     url: '/benefitni-programy',
                    //     isOutlink: true,
                    //     title: 'Benefitní programy',
                    // },
                    // {
                    //     url: '/najdete-v-lekarne',
                    //     isOutlink: true,
                    //     title: 'Najdete v lékárně',
                    // },
                    // {
                    //     url: '/aktualni-akcni-letak',
                    //     isOutlink: true,
                    //     title: 'Aktuální akční leták',
                    // },
                    // {
                    //     url: '/certifikaty-prirodnich-produktu',
                    //     isOutlink: true,
                    //     title: 'Certifikáty přírodních produktů',
                    // },
                    // {
                    //     url: '/kontakt#telefonni-objednavka',
                    //     isOutlink: true,
                    //     title: 'Objednávka po telefonu',
                    // },
                    // {
                    //     url: '/form-recommend',
                    //     isOutlink: true,
                    //     title: 'Dejte nám tip na produkty',
                    // },
                    // {
                    //     url: 'https://www.pilulka.cz/prehled-znacek',
                    //     isOutlink: true,
                    //     title: 'Přehled značek',
                    // },
                    // {
                    //     url: 'https://www.pilulka.cz/prehled-produktovych-rad',
                    //     isOutlink: true,
                    //     title: 'Přehled produktových řad',
                    // },
                ],
            },
            {
                title: 'Snadný nákup',
                links: [
                    {
                        url: 'https://www.pilulka.cz/benefity',
                        isOutlink: true,
                        title: 'Benefitní programy',
                    },
                    {
                        url: 'https://www.pilulka.cz/aktualni-akcni-letak',
                        isOutlink: true,
                        title: 'Aktuální akční leták',
                    },
                    {
                        url: 'https://www.pilulka.cz/pilulka-lekarny',
                        isOutlink: true,
                        title: 'Pilulka Lékárny',
                    },
                    {
                        url: 'https://www.pilulka.cz/pilulka-premium',
                        isOutlink: true,
                        title: 'Pilulka Premium',
                    },
                    {
                        url: 'https://www.pilulka.cz/mobilni-aplikace',
                        isOutlink: true,
                        title: 'Mobilní aplikace',
                    },
                    {
                        url: 'https://www.pilulka.cz/prehled-znacek',
                        isOutlink: true,
                        title: 'Přehled značek',
                    },
                    // {
                    //     url: '/pilulka-expres',
                    //     isOutlink: true,
                    //     title: 'Pilulka Expres',
                    // },
                    // {
                    //     url: '/pilulka-lekarny',
                    //     isOutlink: true,
                    //     title: 'Pilulka Lékárny',
                    // },
                    // {
                    //     url: '/pilulka-box',
                    //     isOutlink: true,
                    //     title: 'Výdejní Boxy',
                    // },
                    // {
                    //     url: '/pilulka-premium',
                    //     isOutlink: true,
                    //     title: 'Pilulka Premium',
                    // },
                    // {
                    //     url: '/mobilni-aplikace',
                    //     isOutlink: true,
                    //     title: 'Mobilní aplikace',
                    // },
                    // {
                    //     url: 'https://www.pluscare.cz',
                    //     isOutlink: true,
                    //     title: 'Aplikace Plus Care',
                    // },
                    // {
                    //     url: '/poradna',
                    //     isOutlink: false,
                    //     title: 'Poradna',
                    // },
                    // {
                    //     url: 'https://erecept.pilulka.cz',
                    //     isOutlink: true,
                    //     title: 'Erecept',
                    // },
                    // {
                    //     url: '/jak-se-pridat-do-pilulka-recenzniho-klubu',
                    //     isOutlink: true,
                    //     title: 'Recenzní klub',
                    // },
                    // {
                    //     url: '/doporucte-a-vydelavejte',
                    //     isOutlink: true,
                    //     title: 'Doporučte Pilulka.cz',
                    // },
                    // {
                    //     url: '/darkove-poukazy',
                    //     isOutlink: true,
                    //     title: 'Dárkové poukazy',
                    // },
                    // {
                    //     url: 'https://pilulkalab.com',
                    //     isOutlink: true,
                    //     title: 'Accelerator Pilulka Lab',
                    // },
                    // {
                    //     url: '/pilulka-benefit',
                    //     isOutlink: true,
                    //     title: 'Pilulka Benefit',
                    // },
                ],
            },
            {
                title: 'O Pilulce',
                links: [
                    {
                        url: 'https://www.pilulka.cz/o-nas',
                        isOutlink: true,
                        title: 'O nás',
                    },
                    {
                        url: 'https://www.pilulka.cz/pro-investory',
                        isOutlink: true,
                        title: 'Pro investory',
                    },
                    {
                        url: 'https://pracevpilulce.cz/',
                        isOutlink: true,
                        title: 'Pracujte v Pilulce',
                    },
                    {
                        url: 'https://www.pilulka.cz/obchodni-podminky',
                        isOutlink: true,
                        title: 'Obchodní podmínky',
                    },
                    {
                        url: 'https://www.pilulka.cz/zpracovani-osobnich-udaju',
                        isOutlink: true,
                        title: 'Ochrana osobních údajů',
                    },
                    // {
                    //     url: '/kontakt',
                    //     isOutlink: true,
                    //     title: 'Kontakt',
                    // },
                    // {
                    //     url: '/o-nas',
                    //     isOutlink: true,
                    //     title: 'O nás',
                    // },
                    // {
                    //     url: '/pro-firmy',
                    //     isOutlink: true,
                    //     title: 'Pro firmy',
                    // },
                    // {
                    //     url: '/pro-media',
                    //     isOutlink: true,
                    //     title: 'Pro média',
                    // },
                    // {
                    //     url: '/pro-investory',
                    //     isOutlink: true,
                    //     title: 'Pro investory',
                    // },
                    // {
                    //     url: '/obchodni-podminky',
                    //     isOutlink: true,
                    //     title: 'Obchodní podmínky',
                    // },
                    // {
                    //     url: '/zpracovani-osobnich-udaju',
                    //     isOutlink: true,
                    //     title: 'Ochrana osobních údajů',
                    // },
                    // {
                    //     url: '/affiliate-program',
                    //     isOutlink: true,
                    //     title: 'Affiliate program',
                    // },
                    // {
                    //     url: 'https://pracevpilulce.cz',
                    //     isOutlink: true,
                    //     title: 'Pracujte v Pilulce',
                    // },
                    // {
                    //     url: 'https://marketplace.pilulka.cz',
                    //     isOutlink: true,
                    //     title: 'Prodávejte na Pilulka.cz',
                    // },
                ],
            },
        ],
        socials: [
            {
                link: 'https://www.facebook.com/Pilulka.cz',
                title: 'Facebook',
                icoCssClass: 'ico--footer-fb',
            },
            {
                link: 'https://www.instagram.com/pilulkacz',
                title: 'Instagram',
                icoCssClass: 'ico--footer-instagram',
            },
            {
                link: 'https://twitter.com/pilulkacz',
                title: 'Twitter',
                icoCssClass: 'ico--footer-twitter',
            },
            {
                link: 'https://www.linkedin.com/company/dr-pilulka-s-r-o-/',
                title: 'LinkedIn',
                icoCssClass: 'ico--footer-linkedin',
            },
        ],
        // TODO fix the icons for flags
        flags: [
            {
                code: 'sk',
                url: 'https://www.pilulka.sk',
            },
            // {
            //     code: 'hu',
            //     url: 'https://www.pilulka.hu',
            // },
            // {
            //     code: 'at',
            //     url: 'https://www.pilulka.at',
            // },
        ],
        translations: {
            defaultLanguage: 'cz',
            pageLanguage: 'cs',
            allowed: ['en', 'uk'],
            flags: [
                {
                    code: 'cz',
                    title: 'Čeština',
                },
                {
                    code: 'en',
                    title: 'English',
                },
                {
                    code: 'uk',
                    title: 'Українська',
                },
            ],
            automaticTranslationWasUsed: 'K překladu byl použitý automatický překlad. Za případné chyby v překladu se omlouváme.',
            keepTranslation: 'Ponechat překlad',
            keepTheOriginalWording: 'Nechat původní znění',
        },
        ios: {
            link: 'https://itunes.apple.com/us/app/pilulka-cz/id1287999800?l=cs&ls=1',
            alt: 'Stáhnout na App Store',
        },
        android: {
            link: 'https://play.google.com/store/apps/details?id=cz.pilulka.shop&hl=cs',
            alt: 'Stáhnout na Google Play',
        },
        cookiesText:
            'Při poskytování služeb nám mohou pomáhat soubory cookie. Plně respektujeme nastavení vašeho prohlížeče. Chcete-li cookie vypnout, učiňte tak ve vašem prohlížeči.',
        recomendedYou: 'Poradíme vám',
        ratingShop: {
            title: 'Hodnocení',
            rating: 4.8,
            text: 'doporučuje nákup na Pilulka.cz',
        },
        getDiscount: 'Nejlepší akce a slevy ve vašem e-mailu',
        wannaGetDiscount: 'Chci to',
    },
    basic: {
        maxAmount:
            "V jedné objednávce je možné zakoupit maximálně {n} ks tohoto produktu. Jestliže potřebujete nakoupit více kusů, kontaktujte nás prosím na b2b{'@'}pilulka.cz.",
        maxAmountPerOrder: 'Dosažený limit maximálního množství kusů v jedné objednávce.',
    },
    locale: 'cs',
    localeIso: 'cs-CZ',
    currency: 'CZK',
    currencySymbol: 'Kč',
    mainTitle: 'Pilulka.cz',
    legalName: 'Pilulka Lékárny a.s.',
    intervalDiscountPrice: '10',
    from: 'z',
    pieces: 'ks',
    closed: 'zavřeno',
    credits: 'kreditů | kredit | kredity | kreditů',
    showText: 'Zobrazit více',
    hideText: 'Skrýt',
    detail: 'Detail',
    close: 'Zavřít',
    products: 'Produkty',
    download: 'Stáhnout',
    loading: 'Načítání',
    top: 'Nahoru',
    notImage: 'Nemáme fotku',
    appId: '1287999800',
    stripSpaceSymbol: 'g|ml|mg|l|cps|ks|cpr|pl|mg/ml',
    somethingWentWrong: 'Něco se nepovedlo',
    homepageTitle: 'Pilulka.cz - lékárna pro lepší život',
    metaDescription:
        'Pilulka je nejsnazší cesta ke zdraví. Podporujeme prevenci, udáváme trendy moderního lékárenství a nabízíme vše pro zdravé tělo, sebevědomí i domov.',
    cookies: {
        ad_storage: 'Reklamní cookies',
        analytics_storage: 'Analytické cookies',
        functionality_storage: 'Funkční / provozní cookies',
    },
    links: {
        basket: '/kosik',
    },
    askUs: {
        title: 'Zeptejte se nás',
        yourEmail: 'Váš e-mail',
        yourQuestion: 'Váš dotaz',
        itemsWithAsterisk: 'Položky označené hvězdičkou',
        areRequired: 'jsou povinné',
        sendQuestion: 'Odeslat dotaz',
    },
    organization: {
        name: 'Pilulka',
        slogan: 'lepší život',
        tel: '+420222703000',
        addressLocality: '',
        postalCode: '',
        streetAddress: '',
    },
    category: {
        title: 'Kategorie',
        bestSellers: 'Nejprodávanější produkty',
        notFoundProductlist: 'Zákazníci nejčastěji kupují',
        notFoundBannerList: 'Top akce na Pilulce',
    },
    brands: 'Značky',
    gift: 'Dárek',
    todayAction: 'Dnešní akční cena',
    of: 'z',
    url: {
        cartStep1: '/kosik',
        search: '/hledej',
        category: {
            sale: '/akce-a-slevy',
            saleAndDiscount: '/akce-a-slevy',
        },
        static: {
            pilulkaClub: '/pilulka-klub',
        },
        user: {
            login: '/prihlasit-se',
            logout: '/backend/logout',
            profile: '/muj-ucet',
            profileSettings: '/informace-o-uzivateli',
            changePassword: '/zmena-hesla',
            orders: '/objednavky',
            feedback: '/hodnoceni',
            myFavorite: '/me-oblibene',
            forgottenPassword: '/zapomenute-heslo',
            registration: '/registrace',
            deleteCreditCard: '/backend/user-delete-credit-card',
        },
        complaint: {
            createNew: '/complaint-step1?withdrawal=0',
            homepage: '/moje-reklamace',
        },
        counselling: '/poradna',
        mobileApplication: '/mobilni-aplikace',
        pharmacies: '/pilulka-lekarny',
        orderRepeat: '/backend/order/repeat',
        cancelOrderByCustomer: '/backend/order/cancel_by_customer',
        prolongOrderByCustomer: '/backend/order/prolong_by_customer',
        pickupPlaceList: '/mapa-odbernych-mist',
    },
    siteHeader: {
        logoTitle: 'Pilulka.cz - vaše online lékárna s více než 1247 odběrnými místy  po ČR',
        basket: 'Košík',
        category: 'Kategorie',
        chat: 'Chat',
        search: {
            title: 'Vyhledat',
            placeholder: 'Hledejte na Pilulka.cz',
            notfound: 'Zkontrolujte prosím vyhledávané slovo.',
            label: 'Hledat',
        },
        login: {
            email: 'Váš e-mail',
            password: 'Vaše heslo',
            showPassword: 'Zobrazit heslo',
            sendForgottenPassword: 'Zapomněl jsem heslo',
            title: 'Moje Pilulka',
            label: 'Přihlásit',
            loginAction: 'Přihlásit se',
            loginWithFacebook: 'Přihlásit přes Facebook',
            loginWithGoogle: 'Přihlásit přes Google',
            register: 'Registrovat se',
            favoriteAndRecentlyPurchasedProducts: 'Oblíbené a zakoupené produkty',
            myRatings: 'Moje hodnocení',
            favoriteProducts: 'Oblíbené produkty',
            reviewClub: 'Recenzní klub',
            userInfo: 'Osobní údaje',
            credits: '%{credits} kreditů',
            orders: 'Objednávky',
            ratings: 'Hodnocení produktu',
            myProfile: 'Můj profil',
            logout: 'Odhlásit se',
            google: 'Přihlásit přes Google',
        },
        cartBox: {
            basket: 'Košík',
            cart: 'Košík',
            goBasket: 'Přejít do košíku',
            greatYouAreGettingFreeDelivery: {
                text: 'Skvělé! Získáváte',
                uppercase: 'dopravu zdarma!',
            },
            greatYouAreGettingDiscountedDelivery: {
                text: 'Skvělé! Získáváte',
                uppercase: 'slevu na dopravu!',
            },
            youDoNotHaveANythingInYourBasketYet: 'Ve svém košíku zatím nic nemáte',
            checkOutOurPriceHits: 'Podívejte se na naše cenové trháky',
            buyMoreAndGetFreeDelivery: 'Nakupte zboží ještě za %{price} a dopravu máte zdarma!',
            showAllProductsInTheCart: '- | - | Zobrazit všechny {n} produkty v košíku | Zobrazit všech {n} produktů v košíku',
        },
        menu: {
            transport: 'Doprava',
            club: 'Pilulka Klub',
            favorite: 'Mé oblíbené produkty',
        },
        allProducts: 'Zobrazit všechny produkty',
        seeAllCategory: 'Zobrazit vše v kategorii',
        sale: {
            title: 'Akce a slevy',
            url: '/akce-a-slevy',
        },
        moreCategories: 'Více kategorií',
        clinic: {
            url: '/pilulka-klinika',
            text: 'Klinika',
        },
        erecept: {
            url: 'https://erecept.pilulka.cz/',
            title: 'Léky na eRecept',
            text: 'eRecept',
        },
        favorite: 'Oblíbené',
    },
    footer: {
        followUs: 'Sledujte nás\n',
        customerSupport: {
            phone: '+420 222 703 000',
            phoneAvailability: 'Po - Pá 8:00 - 18:00',
            email: "dotazy{'@'}pilulka.cz",
            emailAvailability: 'Po - Pá 8:00 - 22:00<br> Sobota 18:00 - 22:00 <br /> Neděle 15:00 - 20:00',
            chat: 'Chat',
            chatAvailability: 'Po - Pá 8:00 - 20:00<br>Sobota 18:00 - 22:00 <br> Neděle 15:00 - 22:00',
        },
        weRespondEveryWeekday: 'weRespondEveryWeekday',
        cookiesText:
            'Při poskytování služeb nám mohou pomáhat soubory cookie. Plně respektujeme nastavení vašeho prohlížeče. Chcete-li cookie vypnout, učiňte tak ve vašem prohlížeči.',
    },
    serviceHomepage: {
        noResultsTitle: 'Ve vašem okolí jsme bohužel žádné kliniky nenašli',
        noResultsText: 'Zkuste změnit polohu nebo prozkoumejte kliniky v dalších městech',
        noResultsButton: 'Prozkoumat',
    },
    carouselHomepage: {
        title: 'Super nabídka',
        lastViewProducts: 'Naposledy navštívené',
        purchasedProducts: 'Zakoupené produkty',
        basketProducts: 'Uvízlo v košíku',
        wishlistProducts: 'Wishlist',
        topProducts: 'Nejoblíbenější produkty',
        recentlyPurchasedProducts: 'Vaše dříve zakoupené a oblíbené produkty',
        onePlusOneProducts: 'Akce 1+1 ZDARMA',
        twoPlusOneProducts: 'Akce 2+1 ZDARMA',
        lastBoughtRecommendedProducts: 'Vaše oblíbené zboží',
        defaultBannersTitle: 'Vítejte na Pilulce',
    },
    serviceDetail: {
        qualityGuarantee: 'Garance kvality',
        qualityVariant: 'Varianty služby',
        closestServiceOffice: 'Nejbližší pobočka',
        openToday: 'Dnes otevřeno',
        openingHours: 'Otevírací doba',
        showAllOffices: 'Zobrazit všechny pobočky',
        ratingWasAdded: 'Děkujeme za vaše hodnocení. Již brzy se objeví u hodnoceného produktu.',
        reviewRead: 'Přečíst {n} recenzi | Přečíst {n} recenzi | Přečíst {n} recenze | Přečíst {n} recenzí',
        commentsRead: 'Přečíst {n} hodnocení',
        questionRead: 'Zobrazit {number} dotazů',
    },
    search: {
        searchResultsForTerm: 'Výsledky hledání pro výraz',
        searchBrands: 'Značky',
        searchCategories: 'Kategorie',
        searchManufacturers: 'Výrobci',
        searchProductLines: 'Produktové řady',
        searchPharmacies: 'Lékárny',
        searchServiceOffices: 'Pobočky služeb',
        searchServices: 'Služby',
        searchStaticContents: 'Článek',
    },
    rating: {
        title: 'Hodnocení',
        shareProductOnFB: 'Sdílet službu na Facebooku',
        writeRating: 'Napište vlastní hodnocení',
        showAllRatings: 'Zobrazit všechna hodnocení',
        noRatings: 'Ohodnoťte tento produkt jako první.',
        percentCustomersRecommended: '{n}% zákazníků doporučuje',
        users: 'Hodnotil {n} zákazník | Hodnotil {n} zákazník | Hodnotili {n} zákazníci | Hodnotilo {n} zákazníků',
        write: 'Napsat hodnocení',
        useful: 'Užitečné?',
        login: {
            mustLogin: 'Pro hodnocení je potřebné <a href="/prihlasit-se">se přihlásit</a> do vašeho profilu.',
            signIn: 'Pro hodnocení je potřebné <a href="/prihlasit-se">se přihlásit</a> do vašeho profilu.',
        },
        averageRating: '{n} z 5',
        totalRating: '({n} hodnocení)',
        showAllRatingTooltip: 'Zobrazit hodnocení|Zobrazit {n} hodnocení|Zobrazit {n} hodnocení|Zobrazit všech {n} hodnocení',
    },
    days: {
        monday: 'Pondělí',
        tuesday: 'Úterý',
        wednesday: 'Středa',
        thursday: 'Čtvrtek',
        friday: 'Pátek',
        saturday: 'Sobota',
        sunday: 'Neděle',
    },
    voucher: {
        boughtVouchers: 'Zakoupené vouchery',
        applied: 'Uplatněn',
        notApplied: 'Neuplatněn',
        noVouchersFound: 'Nemáte žádné platné vouchery',
        code: 'Kód',
        service: 'Služba',
        validity: 'Platnost',
        application: 'Uplatnění',
        serviceOffice: 'Pobočka',
        title: 'Váš voucher',
        validTill: 'Platnost do {date}.',
        detail: 'Detail služby',
        inPrice: 'V ceně',
        howUse: 'Jak uplatnit',
        codeVoucher: 'Kód voucheru',
        validTillLabel: 'Platnost voucheru',
        useLabel: 'Uplatnění',
        text1: 'Voucher byl zaslán na Vámi zvolenou e-mailovou adresu. Pro jeho uplatnění voucher vytiskněte nebo využijte jeho online verzi.',
        text2: 'Voucher, jeho číslo či výše uvedený kód, předložte obsluze pobočky, na níž si přejete službu čerpat.',
        kontakt: {
            title: 'Potřebujete poradit?',
            tel: '+420 222 703 000',
            open: 'Po - Pá: 8:00 - 16:00',
            mail: 'dotazy@pilulka.cz',
        },
        serviceBox: {
            title: 'Vyhledání nejbližších poboček',
            perex: 'Nastavte svou adresu pro vyhledání nejbližších poboček.',
            email: 'E-mail',
            tel: 'Tel.',
            detail: 'Detail pobočky',
        },
    },
    userAccount: {
        youDoNotHaveACardYet: 'Nemáte zatím žádnou kartu',
    },
    serviceManufacturerDetail: {
        services: 'Služby',
        serviceOffices: 'Pobočky',
    },
    productList: {
        noResultsTitle: 'Nenalezeny žádné výsledky',
        noResultsText: 'Požadovaným filtrům bohužel neodpovídá žádná služba.',
        noResultsDiscussion: 'Nenalezeny žádné výsledky',
        button: 'Vyhledat vzdálenější služby',
        sort: 'Seřadit',
        filter: 'Filtrovat',
        filterAndSort: 'Filtrovat a řadit',
        sorting: 'Řazení',
        clearFilter: 'Vymazat filtry',
        result: 'Nalezeno {totalCount} výsledků',
        services: 'Služby',
        viewMore: 'Zobrazit další nabídky',
        branches: 'Pobočky',
        expiration: 'Datum expirace',
        perPiece: 'za kus',
    },
    services: {
        nBranchesOffer: 'Nenabízí žádná pobočka | Nabízí {n} pobočka | Nabízí {n} pobočky | Nabízí {n} poboček',
    },
    whisperer: {
        showXProducts: 'Zobrazit 0 produktů | Zobrazit 1 produkt | Zobrazit {n} produkty | Zobrazit {n} produktů',
    },
    serviceList: {
        show: 'Zobrazit',
        offersOver10km: 'Nabídky nad 10 km',
    },
    location: {
        yourLocation: 'Vaše aktuální poloha',
        filter: {
            title: 'OZNAČTE VAŠI POLOHU A MY VÁM UKÁŽEME NEJBLIŽŠÍ KLINIKY',
            location: 'Lokalita',
            yourLocation: 'Vaše poloha',
            change: {
                text: 'Změnit',
                small: 'polohu',
            },
        },
    },
    maps: {
        link: 'https://mapy.cz/zakladni?x=%{lng}&y=%{lat}&z=17&source=coor&id=%{lng}%2C%{lat}',
    },
    club: {
        title: 'Připojte se do Pilulka rodiny',
        text: 'Získejte spoustu výhod v naší velké rodině',
        buttonText: 'Připojit se',
        url: '/registrace',
    },
    reviewClub: {
        title: 'Odměníme vás za každou recenzi',
        desc: 'Přidejte se do Recenzního klubu a získejte odměnu 200 Kč za každou napsanou recenzi. Nejenže pomůžete dalším zákazníkům při výběru produktů, ale také ušetříte nějakou tu korunu.',
        textButton: 'Přidat do klubu',
        tests: 'Testy',
        review: 'Recenze | Recenze | Recenze | Recenzí',
        clubText:
            'Jako člen <a href="/recenzni-klub">Pilulka Recenzního klubu</a> můžete na zakoupené produkty přidávat tyto detailní recenze. Přidejte se k recenzentům a sbírejte odměny za každý ohodnocený produkt.',
        comments: 'Hodnocení',
        orders: 'Objednávek',
        recomended: 'doporučuje',
        isEmployee: 'Ověřený zákazník',
        noEmployeeReview: 'Neověřená recenze',
        readAllReview: 'Přečíst celou recenzi',
        best: {
            title: 'Nejlepší recenze',
            recommend: 'doporučuje',
            verified: 'Ověřený zákazník',
            textButton: 'Přečíst celou recenzi',
        },
        reviews: 'Hodnocení',
        employee: 'Pilulka zaměstnanec',
        verified: 'Ověřený nákup',
        points: 'Bod | Body | Body | Bodů',
        customerRecommended: 'Zákazník doporučuje',
        customerNotRecommended: 'Zákazník nedoporučuje',
        like: 'Užitečné',
        unlike: 'Neužitečné',
        backToList: 'Zpět na výpis',
        readAllReviewFromOurCustomers: 'Přečíst všechny recenze našich zákazníků',
        allTitle: '',
        vipReview: 'VIP recenze',
    },
    mobileApp: {
        title: 'Aplikace pro lepší život',
        banner: {
            title: 'Pilulka',
            text: 'Otevřít v aplikaci Pilulka',
            open: 'otevřít',
        },
        ios: {
            link: 'https://itunes.apple.com/us/app/pilulka-cz/id1287999800?l=cs&ls=1',
            alt: 'Stáhnout na App Store',
        },
        android: {
            link: 'intent://play.google.com/store/apps/details?id=cz.pilulka.shop&hl=cs/#Intent;package=cz.pilulka.shop;end',
            alt: 'Stáhnout na Google Play',
        },
        box: {
            title1: 'Sledujte kurýra Pilulka Expres',
            text1: 'Budete vědět přesně kdy vám balíček dorazí',
            title2: 'Odměňujeme vás za pohyb',
            text2: 'Za pravidelný pohyb od nás dostane kredity na nákup',
        },
        homepageBanner: {
            easierShoppingWithPilulkaApp: 'Jednodušší nakupování s aplikací Pilulka',
            quickAndRepeatedPurchaseViaOneClick: 'Rychlý opakovaný nákup na jeden klik',
            discountsAndBetterPricesInApp: 'Speciální ceny a akce v aplikaci',
            youKnowExactlyWhereYourOrderIs: 'Přesně víte, v jakém stavu a kde je vaše objednávka',
        },
    },
    formRecommend: {
        h1: 'Doporučte nám',
        h2: 'Chybí vám na Pilulce oblíbený produkt?',
        p: 'Hledali jste, ale nenašli – váš produkt na Pilulce zkrátka chybí. Můžeme se ho však pokusit zařadit do nabídky, když nám o něm napíšete. Vyplňte prosím formulář níže a popište nám konkrétní produkty, které byste na Pilulce chtěli vidět. My si projdeme vaše nápady a možná své oblíbence brzy objevíte i v naší nabídce. :)',
        h3: 'Napište nám',
        fullName: 'Jméno a příjmení:',
        btnText: 'Odeslat tip',
        textarea:
            'Uveďte prosím název, případně popis produktu, který byste rádi viděli v naší nabídce, a my uděláme vše pro to, aby se zde objevil.',
        agree: {
            text: 'Souhlasím s ',
            url: '/zpracovani-osobnich-udaju',
            link: 'Pravidly ochrany a zpracování osobních údajů.',
        },
        fill: 'Vyplňte prosím všechna pole',
        send: 'Děkujeme za váš tip!',
    },
    cookiebar: {
        title: 'Aby Pilulka fungovala jak má (souhlas s cookies)',
        text: 'Pro co nejlepší zážitek z nakupování. Aby fungovalo správně vyhledávání, abychom si pamatovali, co máte v košíku, abyste jednoduše zjistili stav vaší objednávky, abychom vás neobtěžovali nevhodnou reklamou a abyste se nemuseli pokaždé přihlašovat. Proto od vás potřebujeme souhlas se zpracováním souborů cookie - malých souborů, které se dočasně ukládají ve vašem prohlížeči. Děkujeme, že nám ho dáte a pomůžete nám Pilulku zlepšovat. Budeme se k vašim datům chovat citlivě a slušně.',
        manageText: 'Spravovat cookies',
        manageLink: '/pravidla-pouzivani-cookies',
        denyText: 'Odmítnout všechny cookies',
        acceptText: 'Přijmout všechny cookies',
        allowSelection: 'Povolit výběr',
        acceptLink: '',
    },
    deliveries: {
        title: 'Možnosti dopravy - Zdarma od 1 499 Kč',
        desc: 'Orientační čas doručení, může se lišit v závislosti na vytíženosti skladu a dopravců. O přesném termínu vás budeme včas informovat po vytvoření objednávky. ',
        pharmacies: 'Seznam lékáren',
        zasilkovna: 'Seznam výdejen',
        insertAddressForMoreAccurateDeliveryOptions: 'Zadejte adresu pro přesnější možnosti doručení',
    },
    product: {
        insertToCart: 'Vložit&nbsp;do&nbspkošíku',
        addToCard: 'Do košíku',
        preorder: 'Předobjednat',
        forPickupWithinPharmacy: 'Ihned v lékárně',
        basket: 'V košíku máte {basketAmount}&nbsp;ks za {totalPrice}',
        buyMore: 'Přikoupit',
        offers: {
            apply: 'Akce <strong>{n}</strong> aplikována.',
            notApply: 'Akce <strong>{n}</strong>. Pro aplikování akce přidejte do košíku potřebné množství.',
            buttonAdd: 'Přidat další|Přidat další|Přidat {n} kusy|Přidat {n} kusů',
        },
        inPilulkaAppFor: 'V Pilulka aplikaci za: <br /><strong>{price}</strong>',
        downloadApp: 'Stáhnout aplikaci',
        downloadAppLink: '/mobilni-aplikace',
        sponsored: 'Sponzorováno',
        productIsPremiumExclusive: 'Pouze pro Pilulka Premium',
        moreAboutPilulkaPremium: 'Více o Pilulka Premium',
        action: 'Akce',
        priceWithPilulkaPremium: 's Pilulka Premium',
        premiumFromXPerMonth: 'Od 12 Kč / měsíc',
    },
    reviewForm: {
        title: 'Hodnocení:',
        service: 'Pobočka:',
        applied: 'Uplatněno:',
        yourRating: 'Vaše hodnocení:',
        for: 'Pro:',
        against: 'Proti:',
        evaluation: 'Hodnocení parametrů:',
        evaluationText: 'Text hodnocení:',
        personalData: {
            text: 'Souhlasím s ',
            url: '/zpracovani-osobnich-udaju',
            link: 'Ochrana osobních údajů',
        },
        select: {
            text: 'Položky označené',
            textEnd: 'jsou povinné.',
        },
        send: 'Ohodnotit',
        error: 'Hodnocení bohužel nebylo přidáno',
        thankYou: 'Vaše recenze byla přidána, brzy se objeví u produktu. Děkujeme!',
    },
    slides: {
        previous: 'Předchozí',
        next: 'Následujicí',
    },
    formsElement: {
        fullName: 'Jméno a příjmení',
        email: 'E-mail',
        password: 'Heslo',
        orderNumber: 'Číslo objednávky',
        lastName: 'Příjmení',
        bankAccount: 'Číslo bankovního účtu',
        bankAccountDesc: 'V případě řešení reklamace vrácením peněz vám je zašleme na tento účet',
    },
    productDetail: {
        additionalInfoFor: 'Doplňující informace pro',
        additionalInfoAndLeafletFor: 'Doplňující informace a příbalový leták pro',
        reviewsForProduct: 'Recenze a zkušenosti s produktem',
        showMore: 'Zjistit více',
        moreAboutPilulkaPremium: 'Více o Pilulka Premium',
        removeFromBasket: 'Odebrat z košíku',
        addToBasket: 'Přidat do košíku',
        recommendationCarouselTitle: 'Přihoďte si ještě do košíku',
        addToCartPreorder: 'Předobjednat',
        preorder: {
            availabilityText:
                '<strong>Předobjednávka produktu</strong>Předpokládaný termín doručení je {deliveryDate}. Termín pro vás budeme po dokončení objednávky průběžně aktualizovat.',
        },
        monthlyPackages: {
            title: 'Výhodná balení',
            monthlyPackage1: {
                title: '1 měsíční balení',
            },
            monthlyPackage3: {
                title: '3 měsíční balení',
            },
            monthlyPackage6: {
                title: '6 měsíční balení',
            },
            freeDelivery: 'Doprava zdarma',
        },
        tabs: {
            allTitle: 'Vše o produktu',
            ratingTitle: 'Hodnocení produktu',
            weTestedTitle: 'Testovali jsme',
            weTestedText: 'Testovali jsme my a naši zákazníci',
            leafletTitle: 'Příbalový leták',
            leafletText: 'Příbalovou informaci můžete stáhnout zde',
            leafletDownload: 'Příbalová informace',
            similarTitle: 'Doporučujeme vám tyto podobné produkty',
            similarTitleNotInStock: 'Chcete produkt dřív? Vyberte si podobný',
            discussionTitle: 'Dotazy',
            discussionText: 'Diskuze k produktu',
            additionalInformation: 'Doplňující informace',
            safetyMessage: 'Bezpečnostní nařízení: ',
            hygienic: {
                title: 'Upozornění:',
                text: 'Z hygienických důvodů zboží nelze vrátit, a to ani ve lhůtě 14 dnů od zakoupení.',
            },
            shortExpiryDate: {
                title: 'Upozornění:',
                text: 'Vzhledem ke krátké době expirace produktu jej nelze vrátit, a to ani do 14 dnů od zakoupení.',
            },
            breastFeeding: {
                title: 'Upozornění:',
                text: 'Kojení je nejpřirozenějším způsobem výživy kojenců.',
            },
            dietarySupplement: {
                title: 'Upozornění:',
                text: 'Nepřekračujte doporučené dávkování. Výrobek neslouží jako náhrada pestré stravy.',
            },
            freelyAvailableMedicine: {
                title: 'Upozornění:',
                text: 'Volně prodejný lék. Přečtěte si pozorně celou příbalovou informaci dříve, než začnete tento přípravek užívat.',
            },
            urlTabs: {
                allTitle: 'vse-o-produktu',
                ratingTitle: 'hodnoceni-produktu',
                weTestedTitle: 'testovali-jsme',
                leafletTitle: 'príbalovy-letak',
                similarTitle: 'muze-se-vam-hodit',
                additionalInformation: 'doplnující-informace',
                discussionTitle: 'dotazy',
            },
            productTitleSuffixes: {
                tabReviews: ' - Recenze a zkušenosti',
                tabLeaflet: ' - Příbalový leták',
                tabDiscussion: '- Diskuze',
            },
        },
        otherManufacturerServices: 'Ostatní služby dodavatele',
        moreInfo: 'více info',
        inStock: 'Skladem 5+ks',
        inStockCount: '{n}ks skladem',
        noStock: 'Skladem u dodavatele',
        outStock: 'Tento produkt není momentálně dostupný, zjišťujeme informace od dodavatele',
        notPurchasable: 'Tento produkt není momentálně dostupný.',
        priceOne: 'Cena za 1 ks',
        selectVariant: 'Vybrat variantu',
        benefits: 'Benefity',
        certificates: 'Certifikáty',
        writeRating: 'Napsat hodnocení',
        buy: 'Nákupem získáte',
        accessories: 'Příslušenství ke zboží',
        quantityDiscount: {
            buyMore: 'Nakupte více a ušetřete',
            discount: 'Ušetřit {number} Kč',
            discountApplying: 'Ušetřeno {number} Kč',
            applied: 'Zvoleno',
            tagTitle: 'Sleva od {number} kusů',
        },
        priceUnit: 'Kč/bal.',
        fromPrice: 'od {price}',
        rating: {
            title: 'Hodnocení produktu',
            rateShowAll: 'Zobrazit další hodnocení',
            yes: 'Ano',
            no: 'Ne',
            recommend: 'Zákazník doporučuje',
            employee: 'Ověřený nákup',
            noEmployeeReview: 'Neověřená recenze',
            showAll: 'Zobrazit všechna hodnocení',
            noItems: 'Nenašli jste co jste hledali?',
            variant: 'Varianta',
            allInfo: 'Podle {n} hodnocení',
            process: {
                url: '/overovani-recenzi',
                text: 'Ověřování recenzí',
            },
        },
        ingredients: 'Složení',
        superPrice: 'Super Cena',
        priceInPharmacy: 'Lékárna',
        competitorPrice: 'Pilulka Cena',
        competitorPriceDescription: 'Pilulka cena označuje velmi výhodnou cenu na trhu.',
        xmasDelivery: 'Garantujeme doručení do Vánoc.',
        xmasDeliveryLink: '/garance-doruceni-do-vanoc',
        xmasDeliveryNot: 'Bohužel negarantujeme dodání do Vánoc.',
        xmasDeliveryInfo: 'Zjistit více',
        productVariants: '- | Zobrazit variantu | {n} varianty | {n} variant',
        trust: {
            headline: 'Hodnocení Pilulka.cz',
        },
        priceWithCode: {
            buy: 'Koupit s kódem',
            buyInApp: 'Cena s kódem v aplikaci',
            buyWithCode: 'Koupit se slevovým kódem: {code}',
            withCode: '<strong>{price}</strong> s kódem {code}',
            withCodeMasterProduct: '<strong>od {price}</strong> s kódem {code}',
            withCodeNoPrice: 's kódem {code}',
            withCodeMasterProductNoPrice: 's kódem {code}',
            continuedTag: 'PRODLOUŽENO',
        },
        benefitPaymentRestriction: 'Nelze platit benefitními body',
        mobileAppPrice: {
            ctaPrice: 'Koupit se slevou v aplikaci',
            cta: 'Akce v aplikaci',
            description: 'v Pilulka Aplikaci',
        },
        giftEvent: {
            withDiscount: 's akcí',
        },
    },
    facebook: {
        sharer: 'https://www.facebook.com/sharer/sharer.php?u=https://www.pilulka.cz/{url}',
    },
    cashback: {
        title: 'Cashback',
        conditions: 'Podrobnosti',
        withPrice: '{price} s cashbackem',
    },
    priceInPharmacy: {
        modalTitle: 'Cashback na produkty v lékárně',
        modalText:
            'Nakupte produkty v Pilulka Lékárně a my vám vrátíme zpět až do 100 % ceny produktu ve formě kreditů na váš Pilulka účet. V Pilulka Lékárně stačí ukázat při placení váš QR kód v mobilní aplikaci. Tato akce platí ve vybraných <a href="/pilulka-klub-v-lekarne">Pilulka Lékárnách</a>.',
        modalFirstPoint: 'Až do 100 % ceny produktu zpět',
        modalSecondPoint: 'Více než polovina léků bez doplatku',
        modalThirdPoint: 'Speciální slevy a akce',
        modalFourthPoint: 'Registrace ZDARMA',
    },
    service: {
        offer: 'Nabídka',
        title: 'Službu můžete využít pouze online, z pohodlí vašeho domova',
        nearestBranch: 'Nejbližší pobočka',
        position: 'od&nbsp;Vás',
        tab: {
            allInfo: 'Vše o službě',
            offices: 'Pobočky',
            comments: 'Hodnocení',
        },
        validTo: 'Platnost do',
        inPrice: 'V ceně',
        howUse: 'Jak uplatnit',
        service: 'Služby',
        branches: 'Nejbližší pobočky dodavatele',
    },
    comments: {
        search: 'Hledejte v hodnoceních',
        all: 'Všechny',
        verified: 'Jen ověřené',
        automaticallyTranslatedFrom: 'Automaticky přeloženo z',
        commentFrom: 'Recenze z',
        showOriginal: 'Zobrazit originál',
        showTranslatedText: 'Zobrazit přeložený text',
        originalRating: 'Originální hodnocení',
    },
    user: {
        card: 'karta',
        pilulkaCard: 'Vaše Pilulka karta',
        addCard: 'Přidat Pilulka kartu',
        account: 'účet',
        onAccount: 'Na svém účtu máte',
        credits: 'kreditů',
        club: 'Pilulka klubu',
        welcome: 'Vítejte',
        recommendation: {
            url: '/doporucte-a-vydelavejte',
            text: 'Doporučte Pilulku a získejte kredit 50 Kč',
        },
        tabs: {
            orders: 'Objednávky',
            vouchers: 'Vouchery',
            evaluation: 'Moje hodnocení',
            user: 'Osobní údaje',
            complaint: 'Reklamace',
            favorite: 'Oblíbené',
            club: 'Recenzní klub',
        },
        howToRedeemCredits: 'Jak uplatnit kredity?',
        creditsHistory: 'Výpis historie kreditů',
        pilulkaPremiumStaticPageUrl: '/pilulka-premium',
        pilulkaPremiumShowMore: 'Zjistit více',
        pilulkaPremiumDeactivate: 'Deaktivovat předplatné Pilulka Premium',
        pilulkaPremiumDeactivated: 'Předplatné Pilulka Premium bylo deaktivováno',
        pilulkaPremiumDeactivateConfirm: 'Opravdu si přejete deaktivovat předplatné premium?',
        pilulkaPremiumActivate: 'Aktivovat předplatné premium',
        pilulkaPremiumUsed: 'Využito',
        pilulkaPremiumRemains: 'Zbývá',
        pilulkaPremiumTotallySaved: 'Celkově ušetřeno',
        pilulkaPremiumYourAreNotMember: 'Nejste členem',
    },
    vouchers: {
        validTill: 'Platnost do',
        code: 'Kód voucheru',
        inPrice: 'V ceně',
        howUse: 'Jak uplatnit',
    },
    dailyOffer: {
        title: 'Trhák dne',
        end: 'Nabídka končí za',
        pieces: 'Zbývá',
    },
    ddBanner: {
        title: 'Každý den nové akce',
        desc: 'podívejte se na nejlepší akce přímo pro vás',
        btnText: 'Prozkoumat',
        link: '/akce-a-slevy',
    },
    listCategory: {
        viewAll: 'Zobrazit více kategorií',
    },
    openHours: {
        title: 'Otevírací doba',
    },
    contact: {
        title: 'Kontaktní údaje',
        tel: 'Tel.',
        distance: 'od Vás',
    },
    perex: {
        products: 'produktů',
        more: 'Zobrazit celý popis',
        less: 'Skrýt celý popis',
    },
    sideBar: {
        expand: 'Chci se objednat',
        sortProduct: 'Seřadit produkty',
        viewProduct: 'Zobrazit produkty',
        filterProduct: 'Filtrovat produkty',
        search: 'Vyhledat...',
        clearAll: 'Vymazat všechny filtry',
        send: 'Potvrdit filtry',
        showList: 'Zobrazit vše ve filtru',
        hideList: 'Skrýt vše ve filtru',
        notFoundItems: 'Nenalezeny žádné výsledky',
    },
    page: {
        500: {
            title: 'Error 500',
            goToHp: 'Přejít na úvodní stránku',
        },
        404: {
            title: 'Stránka nenalezena',
            perex: 'Omlouváme se, ale na tento problém neexistuje žádná pilulka. Vypadá to, že stránka neexistuje nebo byla přemístěná.',
            goToHp: 'Přejít na úvodní stránku',
            subtitle: 'Oblíbené kategorie',
            subcategories: {
                item01: {
                    title: 'Doplňky stravy',
                    url: '/doplnky-stravy',
                    img: '/nuxt-assets/images/png/404/1_kat.png',
                },
                item02: {
                    title: 'Matka a dítě',
                    url: '/matka-a-dite',
                    img: '/nuxt-assets/images/png/404/2_kat.png',
                },
                item03: {
                    title: 'Elektro',
                    url: '/elektro',
                    img: '/nuxt-assets/images/png/404/3_kat.png',
                },
                item04: {
                    title: 'Kosmetika',
                    url: '/kosmetika',
                    img: '/nuxt-assets/images/png/404/4_kat.png',
                },
                item05: {
                    title: 'Drogerie',
                    url: '/drogerie',
                    img: '/nuxt-assets/images/png/404/5_kat.png',
                },
                item06: {
                    title: 'Sport',
                    url: '/sport',
                    img: '/nuxt-assets/images/png/404/6_kat.png',
                },
            },
        },
        hp: {
            topCategories: {
                item01: {
                    title: 'Matka a dítě',
                    img: '/nuxt-assets/images/homepage/topCategories/item01.png',
                    link: '/matka-a-dite',
                    linkText: 'Objevit novinky',
                },
                item02: {
                    title: 'Doplňky stravy',
                    img: '/nuxt-assets/images/homepage/topCategories/item02.png',
                    link: '/doplnky-stravy',
                    linkText: 'Pro vaši imunitu',
                },
                item03: {
                    title: 'Kosmetika',
                    img: '/nuxt-assets/images/homepage/topCategories/item03.png',
                    link: '/kosmetika',
                    linkText: 'Péče o vaše tělo',
                },
                item04: {
                    title: 'Drogerie',
                    img: '/nuxt-assets/images/homepage/topCategories/item04.png',
                    link: '/drogerie',
                    linkText: 'Vše pro vaši domácnost',
                },
                item05: {
                    title: 'Elektro',
                    img: '/nuxt-assets/images/homepage/topCategories/item05.png',
                    link: '/elektro',
                    linkText: 'Chci vědět více',
                },
            },
            categories: {
                item01: {
                    title: 'Sport',
                    img: '/nuxt-assets/images/homepage/categories/item01.png',
                    link: '/sport',
                    linkText: 'Objevit novinky',
                },
                item02: {
                    title: 'Potraviny, nápoje',
                    img: '/nuxt-assets/images/homepage/categories/item02.png',
                    link: '/caje-potraviny',
                    linkText: 'Chci energii',
                },
                item03: {
                    title: 'Ústa a zuby',
                    img: '/nuxt-assets/images/homepage/categories/item03.png',
                    link: '/usta-a-zuby',
                    linkText: 'Chci se otužit',
                },
                item04: {
                    title: 'Zdravotnický materiál',
                    img: '/nuxt-assets/images/homepage/categories/item04.png',
                    link: '/zdravotnicke-potreby',
                    linkText: 'Objevit novinky',
                },
                item05: {
                    title: 'Léky',
                    img: '/nuxt-assets/images/homepage/categories/item05.png',
                    link: '/volne-prodejne-leky',
                    linkText: 'Chci vědět více',
                },
                item06: {
                    title: 'Veterina',
                    img: '/nuxt-assets/images/homepage/categories/item06.png',
                    link: '/veterina',
                    linkText: 'Chci energii',
                },
                item07: {
                    title: 'Klinika',
                    img: '/nuxt-assets/images/homepage/categories/item07.png',
                    link: '/pilulka-klinika',
                    linkText: 'Chci energii',
                },
            },
        },
    },
    paginator: {
        loadMore: 'Dalších {number} produktů',
    },
    benefitsHomepage: {
        benefit1: {
            url: '/pilulka-auto',
            img: 'https://pilulkacz.vshcdn.net/zoh4eiLi/IMG/86400/b2v2FR1SIOu9pJttRYZkhuTTQGF-PFBaDHIzuyFwdZE/aHR0cHM6Ly93d3cucGlsdWxrYS5jei9udXh0LWFzc2V0cy9pbWFnZXMvaWNvbnMvYmVuZWZpdHMvYmVuZWZpdC0wNi14Mi5wbmc.png',
            icon: 'benefit1.svg',
            title: 'Nejrychlejší\n' + 'doručení domů\n' + 's&nbsp;Pilulka&nbsp;Expres',
        },
        benefit2: {
            url: '/pilulka-box',
            img: '/nuxt-assets/images/box.png',
            icon: 'benefit2.svg',
            title: 'Vyzvednutí\n' + 'bez front a&nbsp;čekání\n' + 've&nbsp;Výdejních&nbsp;Boxech',
        },
        benefit3: {
            url: '/mobilni-aplikace',
            img: 'https://pilulkacz.vshcdn.net/zoh4eiLi/IMG/86400/Y32h_tLySMyZknWJGx7n055aIqAWRKNLs_NNE2Er1WA/aHR0cHM6Ly93d3cucGlsdWxrYS5jei9udXh0LWFzc2V0cy9pbWFnZXMvaWNvbnMvYmVuZWZpdHMvYmVuZWZpdC0wMy14Mi5wbmc.png',
            icon: 'benefit3.svg',
            title: 'Speciální akce \n' + 'v&nbsp;naší mobilní \n' + 'aplikaci',
        },
        benefit4: {
            url: '/pilulka-lekarny',
            img: '/nuxt-assets/images/icons/pharmacy/pharmacies.png',
            icon: 'benefit4.svg',
            title: 'Široká síť \n' + 'kamenných lékáren \n' + 'po celé ČR',
        },
    },
    usp: {
        benefit1: {
            icon: 'car1',
            title: 'Doprava ZDARMA při nákupu nad 1 499 Kč',
        },
        benefit2: {
            icon: 'location',
            title: 'Vyzvednutí bez front ve Výdejních Boxech',
        },
        benefit3: {
            icon: 'pharmacy2',
            title: 'Široká síť kamenných lékáren po celé ČR',
        },
        benefit1Alternative: {
            icon: 'car1',
            title: 'V mobilní aplikaci s dopravou ZDARMA',
        },
    },
    uspChristmas: {
        benefit1: {
            icon: 'delivery-circle',
            title: 'Dárky doručíme ještě dnes',
            url: '/garance-doruceni-do-vanoc',
            external: false,
        },
        benefit2: {
            icon: 'christmas-return-circle',
            title: 'Nevhodný dárek vyměníme zdarma',
            url: '/reklamace-a-vraceni-zbozi',
            external: false,
        },
        benefit3: {
            icon: 'christmas-circle',
            title: 'Všechny dárky na jednom místě',
            url: '/darky',
            external: false,
        },
        benefit4: {
            icon: 'christmas-card-circle',
            title: 'Každodenní nadílka<br> v Adventním PilulKalendáři',
            url: 'https://www.instagram.com/pilulkacz/',
            external: true,
        },
    },
    pagination: {
        loadMore: 'Načíst dalších {number}',
    },
    discussions: {
        title: 'Nenašli jste odpověď? Zeptejte se',
        button: 'Položit dotaz',
        verifiedCustomer: 'Ověřený zákazník',
        pilulkaSpecialist: 'Pilulka expert',
        specialist: 'Expert',
        answers: 'Odpovědí',
        questions: 'Otázek',
        respond: 'Odpovědět',
        askQuestion: 'Položit dotaz',
        mustLogin: 'Pro účast v diskuzi je potřebné se přihlásit do vašeho profilu.',
        newAnswer: 'Upozornit na novou odpověď',
        watching: 'Sledovat',
        unWatching: 'Přestat sledovat',
        watchingDiscussions: 'Sledovat diskuzi',
        newest: 'Nejnovější',
        oldest: 'Nejstarší',
        mostRelevant: 'Nejužitečnější',
        watchAnswer: 'Nenašli jste odpověď? Zeptej se nás',
        search: 'Hledat v diskuzích',
        btnShow: 'Zobrazit diskuze v kategorii',
        report: 'Nahlásit',
        closeAnswer: 'Skrýt {n} odpověď',
        close: 'Zavřít',
        open: '- | Zobrazit {n} odpověď | Zobrazit {n} odpovědi | Zobrazit {n} odpovědí',
        useful: 'Užitečné?',
        send: 'Položit dotaz',
        rules: 'Pravidla diskuze',
        agree: 'Položit dotaz',
        questionText: 'Text dotazu',
        questionName: 'Název dotazu',
        formValidatorTitleEmpty: 'Napište prosím název',
        formValidatorTextEmpty: 'Napište prosím text zprávy',
        formValidatorProductDiscussionTermsOfUseEmpty: 'Pro vložení dotazu je nutné souhlasit s podmínkami diskuze.',
        yourAnswer: 'Tvoje odpověď',
        formValidatorReasonEmpty: 'Zadejte prosím důvod hlášení.',
        formValidatorEmailEmpty: 'Prosím vyplňte váš e-mail',
        login: {
            signIn: 'přihlásit',
            mustLogin: 'Pro účast v diskuzi je potřebné se <a href="/prihlasit-se">přihlásit</a> do vašeho profilu.',
        },
        loginUrl: '/prihlasit-se',
        thankYou: 'Děkujeme',
        successfullyReported: 'Nevhodný obsah byl úspěšně nahlášen.',
        ratingPost: 'Hodnocení příspěvku',
        reason: 'Upozornit na nevhodný obsah',
        reasons: {
            reportReasonInappropriate: 'Nevhodný/nerelevantní obsah',
            reportReasonInaccurate: 'Nepřesné či špatné informace',
            reportReasonCopyright: 'Autorsky chráněný obsah',
            reportReasonDuplicate: 'Duplicitní obsah',
            reportReasonOther: 'Jiné',
        },
        messageReport: 'Zpráva (zde popište důvod vašeho upozornění)',
        yourMail: 'Váš e-mail',
        backToListProducts: 'Zpět na výpis produktů',
        rulesModal: {
            title: 'Pravidla Diskuzí na Pilulka.cz',
            text: `<p>
                Služba <strong>Pilulka Diskuze</strong> umožňuje přihlášeným uživatelům zveřejňovat názory a dotazy k danému tématu
                (produkt, služba), reagovat na názory ostatních uživatelů a hodnotit názory ostatních uživatelů.
            </p>
            <h3>Důležité dokumenty</h3>
            <p>Před vstupem do diskuze doporučujeme prostudovat tyto důležité dokumenty:</p>
            <ul>
                <li><a href="/smluvni-podminky-diskuzi-na-pilulka-cz">Smluvní podmínky diskuzí</a></li>
                <li><a href="/obchodni-podminky">Všeobecné obchodní podmínky</a></li>
                <li><a href="https://www.pilulka.cz/zpracovani-osobnich-udaju">Zpracování osobních údajů</a></li>
            </ul>
            <h3>Vstup do diskuze</h3>
            <p>Vstup do diskuze vám bude umožněn za těchto podmínek:</p>
            <ul>
                <li>
                    Máte účet na Pilulka.cz. Do diskuzí je nutné se přihlašovat s účtem na Pilulka.cz. Pokud dosud žádný účet
                    nemáte, můžete si ho založit ZDE.
                </li>
                <li>
                    Souhlasíte se smluvními podmínkami služby Pilulka Diskuze, které jsou kdykoli přístupné na tomto odkazu
                    <a href="/smluvni-podminky-diskuzi-na-pilulka-cz"
                    >https://www.pilulka.cz/smluvni-podminky-diskuzi-na-pilulka-cz</a
                    >.
                </li>
            </ul>
            <h3>Banování</h3>
            <p>
                Uživatelé, kteří budou porušovat <a href="/smluvni-podminky-diskuzi-na-pilulka-cz">smluvní podmínky</a> služby
                Pilulka Diskuze, dostanou tzv. ban. Tj. bude jim na určitou dobu (v některých případech i navždy) znemožněn vstup do
                diskuzí na stránkách Pilulka.cz. Povinností správců Pilulka diskuzí je také mazat příspěvky, které odporují
                <a href="/smluvni-podminky-diskuzi-na-pilulka-cz">smluvním podmínkám</a>.
            </p>
            <p>Provádíme banování skrze e-mail.</p>
            <h3>Problémy s přihlášením</h3>
            <p>Pokud přihlášení do vašeho účtu selže, doporučujeme:</p>
            <ul>
                <li>vypnout doplňky blokující reklamu</li>
                <li>opustit anonymní okno</li>
                <li>vyzkoušet jiný prohlížeč</li>
            </ul>
            <p>
                V případě přetrvávajícího problému kontaktujte naši zákaznickou linku. Kontakty najdete na našich stránkách v sekci
                <a href="/kontakt">Kontakt</a>.
            </p>`,
        },
        termsOfUse:
            'Souhlasím se zpracováním <a href="/smluvni-podminky-diskuzi-na-pilulce" target="_blank">osobních údajů a podmínkami diskuze</a>',
        url: '/diskuze',
        titleSuffix: 'Diskuze',
    },
    reviews: {
        reviewsAndExperience: 'recenze a zkušenosti',
        btnShow: 'Zobrazit recenze v kategorii {feedName}',
        rating: 'Produkty kategorie {feedName} lidé hodnotí na {rating} %',
        title: '{feedName} - recenze a zkušenosti zákazníků',
        url: '/recenze-zkusenosti',
        description:
            'Zajímá vás, jaké zkušenosti mají s produkty {feedName} ostatní zákazníci? Mrkněte na jejich recenze. Ať nekupujete zajíce v pytli.',
        productRating: '<b>Recenze produktu:</b> {productName}',
        showProduct: 'Prohlédnout produkt',
    },
    prebasket: {
        title: 'A máte to v košíku!',
        tocart: 'Přejít do košíku ',
        nostock: 'Tento produkt není skladem, očekáváme, že bude skladem %dateText% Dodání se může zpozdit.',
        continue: 'Pokračovat v nákupu',
        fastCheckout: 'Rychlá platba',
        freeShipping: 'Doprava zdarma',
        freeShippingTitle: 'Kolik schází do dopravy zdarma?',
        freeShippingLeft: 'Zbývá jen: ',
        discountedShipping: 'Sleva na dopravu',
        discountedShippingTitle: 'Kolik schází do slevy na dopravy?',
        notAddOnProducts: 'Přihoďte si ještě do košíku:',
        minOrderPrice: 'Do minimální hodnoty objednávky zbývá',
    },
    substitutions: {
        title: 'Pilulka.cz doporučuje tyto produkty',
    },
    attributes: {
        isRecommended: 'Pilulka doporučuje',
    },
    erotic: {
        taskAge: 'Jsem starší 18 let',
        yesAge: 'Pokračovat',
        noAge: 'Nejsem starší 18 let',
        imageAlt: 'Jsem starší 18 let',
    },
    notFound: {
        category: 'V této kategorii nebyly nalezeny žádné produkty.',
        box1: {
            title: 'Nenašli jste, co jste hledali?',
            desc: 'Pošlete nám tip na produkt a my ho zkusíme zařadit do nabídky.',
            btnText: 'Doporučit produkt',
        },
        box2: {
            title: 'Potřebujete poradit?',
            desc: 'Napište nám a rádi vám pomůžeme s výběrem a vyhledáváním vhodného produktu.',
            btnText: 'Zeptejte se nás',
        },
    },
    reviewModal: {
        title: 'Jak pravděpodobné je, že byste doporučil/a Pilulku vašim blízkým?',
        thankYouNote: 'Děkujeme za hodnocení. Chcete nám sdělit podrobnosti?',
        completelyUnlikely: 'zcela nepravděpodobné',
        completelyLikely: 'velmi pravděpodobné',
        ratingText: 'Text hodnocení - nepovinné',
        feedbackForm: 'Mám zájem vyplnit dotazník pro zlepšení služeb',
        sendRating: 'Odeslat hodnocení',
        feedbackSent: 'Zpětná vazba byla úspěšně přidána. Děkujeme.',
        alreadyRated: 'Tuto službu jste již dříve ohodnotili.',
        thankYouForRating: 'Děkujeme za hodnocení!',
        formLink: 'https://bit.ly/pilulka-dotaznik',
        googleRating: 'Pomozte nám zlepšit naše služby a ohodnoťte nás i na Google.',
        googleCta: 'Udělit hodnocení',
    },
    showInfo: 'Zobrazit celý popis',
    giftsActions: {
        more: 'Podmínky akce',
    },
    warningMessage: 'Informace o akci',
    pilulkaCar: {
        verifyAvailability: 'Ověřit dostupnost',
        goShopping: 'Jít nakupovat',
        changePostCode: 'Změnit PSČ',
        validationTitle: 'Zadejte vaše PSČ pro doručení Pilulka Expres',
        postCode: 'PSČ',
        validationCta: 'Ověřit PSČ',
        selectDifferentShipping: 'Vyberu si jinou dopravu',
        validPostcode: 'Na zadanou PSČ doručujeme',
        notValidPostcode: 'Na zadanou PSČ bohužel nedoručujeme',
        selectedPostCode: 'Doručení proběhne na PSČ {postcode}',
        changeAddressOrDelivery: 'Změňte adresu nebo zvolte jinou dopravu',
        slots: {
            free: 'Zdarma',
            weWontMakeItInTime: 'Nestihneme',
            select: 'Potvrdit',
            occupied: 'Obsazeno',
            available: 'Volno',
        },
    },
    competitorPrice: {
        modalTitle: 'Pilulka cena',
        sale: 'U nás ušetříte',
        competitor: 'Průměrná cena konkurence',
        pilulka: 'Pilulka cena',
        date: 'Naposledy aktualizováno dne',
    },
    productSubstitutions: {
        title: 'Máme pro vás výhodnější produkt',
        badge: 'Výhodnější balení',
        keepCurrentProduct: 'Ponechat stávající volbu',
        chooseBetterProduct: 'Vybrat výhodnější produkt',
    },
    dynamicBundles: {
        title: 'Nakupujte společně',
        discount: 'Ušetříte {discount}',
        totalPrice: 'Cena celkem:',
        changeProduct: 'Vybrat jiný produkt',
        chooseProduct: 'Vybrat produkt',
        cta: 'Koupit společně',
    },
    trust: {
        showTrust: false,
        headline: '',
        title1: '',
        text1: '',
        title2: '',
        text2: '',
        title3: '',
        text3: '',
        title4: '',
        text4: '',
        review: '',
        textReview: '',
        linkTrustBadge: '',
    },
    listPayMethods: [],
    giftAction: {
        addProductText: 'Přidejte další produkt',
        addProductTextWithDiscount:
            'Přidejte další produkt a <strong>získejte slevu {discount}&nbsp;% na&nbsp;nejlevnější produkt</strong>',
        conditionMet: 'Vaše sleva je aplikována v košíku.',
    },
    chatBot: {
        category: [1583, 1556, 3385, 1579, 1586],
        brand: [1065],
        productLine: [947, 381, 884, 4210, 3148],
        product: [
            1545301, 3109867, 3112375, 3112378, 3171067, 3109870, 1545298, 3149380, 3510463, 147324, 224102, 145768, 46718, 235706, 46716,
            235705, 147326, 224107, 224104, 3184462, 224101, 224100, 284484, 3184465, 241225, 1528836, 1423329, 3415600, 1419062, 306539,
            241996, 1371257, 337921, 3413155, 241997, 3149383, 241998, 3413152, 3184459, 3213961, 224109, 224110, 224105, 290010, 241224,
            224103, 224099, 224111, 224112, 224113, 224114, 1382354, 1382355, 3244078, 3244081, 1078025, 1403702, 3243997, 819648,
        ],
        url: ['akce-sonicare-cashback', 'akce-sonicare-for-kids', 'philips-sonicare-powerflosser', 'philips-sonicare-3100'],
    },
    basket: {
        migration: {
            title: 'Dokončit nákup v aplikaci',
            ctaPrice: 'V appce {price}',
            cta: 'Akce v aplikaci',
            qrImg: '/qr-cart-migrate-to-mobile/{basketUid}',
            qrAlt: 'Naskenujte QR kód',
            migrateLink: '/cart-migrate-to-mobile?basketUid={basketUid}',
            migrateCta: 'Přenést košík se slevou do aplikace',
            appInstalled: 'Ujistěte se, že máte aplikaci nainstalovanou.',
            step1: 'Stáhněte si Pilulka Aplikaci a zaregistrujte se',
            step2: 'Pomocí naší QR čtečky v mobilní aplikaci naskenujte QR kód níže. Košík se vám otevře přímo v&nbsp;aplikaci i&nbsp;se&nbsp;slevou.',
            step2Mobile: 'Klikněte na tlačítko níže. Košík se vám otevře přímo v&nbsp;aplikaci i&nbsp;se&nbsp;slevou.',
            step3: 'Dokončete nákup v aplikaci a ušetřete',
        },
    },
    referralProgram: {
        title: 'Sleva 10 %',
        subtitle: 'na další nákup v aplikaci',
        shareLink: 'Sdílejte nás se 3 přáteli a my vás odměníme jakmile u nás nakoupí',
        shareButton: 'Kopírovat odkaz',
        coppied: 'Zkopírováno',
    },
    articles: {
        url: '/clanky',
        widgetTitle: 'Články',
        widgetListButton: 'Všechny články',
        filterTitle: 'Filtrovat články',
        sortTitle: 'Seřadit články',
        sortSubmitLabel: 'Zobrazit články',
        tags: 'Štítky',
        readArticle: 'Přečíst článek',
        paginator: {
            loadMore: 'Dalších {n} článků | Další článek | Dalších {n} články | Dalších {n} článků',
        },
    },
    askYourPharmacist: {
        title: 'Zeptejte se lékárníka',
        text: 'Odborné rady a odpovědi na vaše dotazy, a to z pohodlí vašeho domova.',
        addQuestion: 'Položit dotaz',
        showAllQuestions: 'Všechny dotazy',
        search: 'Hledat',
    },
    paperAuthor: {
        paperAuthor: 'Autor článku',
        allArticlesOfAuthor: 'Všechny články od autora',
    },
    contactFormValidation: {
        email: 'Vyplňte prosím platný e-mail.',
        message: 'Vyplňte prosím zprávu.',
        notSubmitted: 'Formulář nebyl odeslán, kontaktujte prosím vyvojari@pilulka.cz.',
    },
    counselling: {
        title: 'Poradna',
        homepageLink: '/poradna',
        listLink: '/zeptejte-se-lekarnika',
        askPharmacist: 'Zeptejte se lékárníka',
        questionIsAnsweredBy: 'Na dotaz odpovídá:',
        questionFromDate: 'Dotaz z {date}',
        showAnswer: 'zobrazit odpověď',
        backToCounsellingHomepage: 'Zpět do poradny',
        askQuestion: 'Položit dotaz',
        askYourOwnQuestion: 'Položte vlastní dotaz',
        didntFindWhatYouWereLookingFor: 'Nenašli jste, co jste hledali?',
        articles: 'Články',
        allArticles: 'Všechny články',
        allQuestions: 'Všechny dotazy',
        mostSearchedTopics: 'Nejhledanější témata',
        similarQuestions: 'Podobné dotazy',
        recentQuestions: 'Nejnovější dotazy',
        ourPharmacists: 'Naši lékárníci',
        theMostPopularProductsFromOurPharmacies: 'Nejoblíbenější produkty z našich lékáren',
        shopMoreTopics: 'zobrazit více témat',
        searchInputPlaceholder: 'Vyhledat dotaz',
        metaDescription:
            'Zeptejte se lékárníka na cokoliv, co vás zajímá. Odborné rady a odpovědi na vaše dotazy, a to z pohodlí vašeho domova.',
        list: {
            filterTitle: 'Filtrovat dotazy',
            sortTitle: 'Seřadit dotazy',
            sortSubmitLabel: 'Zobrazit dotazy',
            tags: 'Štítky',
        },
        benefits: {
            benefit1: {
                title: 'Rezervujte eRecepty online',
                description: 'Léky na předpis si zarezervujete z pohodlí domova',
                backgroundImagePath: '/nuxt-assets/images/counselling/counselling-benefit-1.png',
                ctaUrl: 'https://erecept.pilulka.cz',
                ctaText: 'Rezervovat',
                ctaTarget: '_blank',
            },
            benefit2: {
                title: 'Široká síť Pilulka Lékáren',
                description: 'Navštivte naše kamenné lékárny po celé ČR',
                backgroundImagePath: '/nuxt-assets/images/counselling/counselling-benefit-2.png',
                ctaUrl: '/pilulka-lekarny',
                ctaText: 'Prozkoumat',
                ctaTarget: '_blank',
            },
        },
        upsertModal: {
            title: 'Zeptejte se lékárníka',
            warning:
                'V případě dotazu na objednávku, dostupnost zboží a služby e-shopu kontaktujte zákaznickou péči, kontaktní formulář najdete na následujícím <a href="/kontakt">odkazu</a>.',
            yourEmail: 'Váš e-mail',
            titleOfQuestion: 'Nadpis dotazu',
            text: 'Text dotazu',
            textPlaceholder: 'Nepodepisujte se prosím. Otázky jsou anonymní.',
            send: 'Odeslat dotaz',
            successMessage: 'Děkujeme. Dotaz byl odeslán. Po jeho zodpovězení vás notifikujeme e-mailem.',
            errors: {
                emailRequired: 'Vyplňte prosím svůj e-mail',
                emailInvalid: 'Vyplňte prosím platný e-mail',
                titleRequired: 'Vyplňte prosím nadpis dotazu',
                textRequired: 'Vyplňte prosím text dotazu',
                checkboxRequired: 'Pro odeslání dotazu musíte souhlasit s podmínkami zpracování osobních údajů',
                titleCannotIncludeAt: "Nadpis dotazu nemůže obsahovat znak {'@'}",
            },
            checkboxAgreeText:
                'Souhlasím se <a href="/zpracovani-osobnich-udaju" target="_blank">zpracováním osobních údajů</a> a <strong>se zveřejněním dotazu v poradně.</strong>',
        },
        paginator: {
            loadMore: 'Dalších {n} dotazů | Další {n} dotaz | Další {n} dotazy | Dalších {n} dotazů',
        },
        recommendations: {
            productsTitle: 'Doporučené produkty',
            categoriesTitle: 'Doporučené kategorie',
        },
    },
    cart: {
        url: {
            step1: '/kosik',
            step2: '/kosik-2',
            step3: '/kosik-3',
            step4: '/objednavka-odeslana',
        },
        nextStep: {
            backDefault: 'Zpět',
            back: 'Zpět do obchodu',
            toStep2: 'Pokračovat na dopravu a platbu',
            backStep2: 'Zpět na dopravu a platbu',
            sendOrder: 'Potvrdit nákup',
            backStep1: 'Zpět do košíku',
            continue: 'Pokračovat',
            continueToPersonalInfo: 'Pokračovat na osobní údaje',
            withPaymentObligation: '',
        },
        basket: 'Košík',
        gift: 'Dárek',
        progressBar: {
            deliveryPay: 'Doprava a platba',
            informationUser: 'Informace o vás',
            finish: 'Děkujeme',
        },
        totalPrice: {
            priceWithVat: 'Celková cena s DPH:',
            savePrice: 'Celkem ušetříte',
            freeDelivery: 'Doprava zdarma',
            discountDelivery: 'Sleva na dopravu',
            rounding: 'Zaokrouhlení',
            shipping: 'Doprava',
        },
        step1: {
            title: 'Objednávka',
            empty: {
                title: 'Váš košík je zatím prázdný',
                continueShopping: 'Jít nakupovat',
            },
            mobileAppOrderStreak: {
                creditCoefficient: '1',
                inMobileApp: 'V mobilní aplikaci můžete získat <strong>{credits} kreditů ({amount})</strong>',
                finishOrderInMobileApp: 'Nakoupit v aplikaci',
                openApp: 'Přenést košík do aplikace',
                steps: {
                    step2: 'Pomocí naší QR čtečky v mobilní aplikaci naskenujte QR kód níže. Košík se vám otevře přímo v aplikaci.',
                    step2Mobile: 'Klikněte na tlačítko níže. Košík se vám otevře přímo v aplikaci.',
                    step3: 'Nakupte v aplikaci a získejte za svůj nákup {credits} kreditů ({amount}).',
                },
            },
            mobileAppOrderMigration: {
                inMobileAppFor: 'V mobilní aplikaci za',
                finishOrderInMobileApp: 'Dokončit nákup v aplikaci',
                android: {
                    link: 'https://play.google.com/store/apps/details?id=cz.pilulka.shop&hl=cs',
                    alt: 'Stáhnout na Google Play',
                },
                ios: {
                    link: 'https://itunes.apple.com/us/app/pilulka-cz/id1287999800?l=cs&ls=1',
                    alt: 'Stáhnout na App Store',
                },
                qrAlt: 'Naskenujte QR kód',
                openApp: 'Přenést košík se slevou do aplikace',
                steps: {
                    step1: 'Stáhněte si Pilulka Aplikaci a zaregistrujte se',
                    step2: 'Pomocí naší QR čtečky v mobilní aplikaci naskenujte QR kód níže. Košík se vám otevře přímo v&nbsp;aplikaci i&nbsp;se&nbsp;slevou.',
                    step2Mobile: 'Klikněte na tlačítko níže. Košík se vám otevře přímo v&nbsp;aplikaci i&nbsp;se&nbsp;slevou.',
                    step3: 'Dokončete nákup v aplikaci a ušetřete',
                    step3Voucher: 's kódem {voucherCode}',
                    step3LimitOncePerUser: '(Sleva je uplatnitelná pouze jednou)',
                },
            },
            recommendationCarouselTitle: 'Přihoďte si ještě do košíku',
            csr: {
                checkboxLabel: 'Chci přispět na dobrou věc',
                modalTitle: 'Pomáhejte s námi',
                addToOrder: 'Přidejte k objednávce',
                moreInfo: 'Více info',
                confirm: 'Potvrdit',
            },
            availableNoWarehouseProductsWarning:
                'Některé produkty nejsou aktuálně skladem, dostupnost ověřujeme u dodavatele. Doručení objednávky se proto může zdržet. Zkuste je nahradit produkty, které máme skladem.',
            unavailableProductsWarning: 'Některé produkty nejsou aktuálně dostupné. Zkuste je nahradit produkty, které máme skladem.',
            substitutions: {
                buttonText: 'Nahradit',
                buttonTextLong: 'Nahradit skladovým',
                productIsNotInStock:
                    'Omlouváme se, ale produkt <a href="{productUrl}" target="_blank" class="text-primary">{productName}</a> <strong style="color: #ff7f41">{productAvailability}</strong>',
                productIsNotAvailable: 'Omlouváme se, ale produkt {productName} je nedostupný',
                modalTitle: 'Nahrazení produktu',
                modalPerex: 'Produkt můžete nahradit a mít objednávku dříve doma.',
                deleteFromBasket: 'Odstranit z košíku',
                leaveWithDelivery: 'Ponechat s doručením {date}',
            },
            credits: {
                useXCredits: '-|Použít {n} kredit|Použít {n} kredity|Použít {n} kreditů',
                useCredits: 'Chcete použít kredity?',
                modal: {
                    title: 'Chcete použít své kredity?',
                    text: 'Kredity lze použít pouze v naší aplikaci. Stáhněte si naší aplikaci a použijte kredity ke snížení ceny vaší objednávky.',
                    bestApp: 'Nejlépe hodnocená aplikace',
                    reviewTitle: 'Perfektní',
                    review:
                        'Perfektní a přehledná aplikace, velký výběr možností dopravy i platby.\n' +
                        ' Široká nabídka přesahující sortiment lékárny. Doporučuji',
                    ratingValue: '4,8',
                    ratingOutOf: 'z 5',
                    ratingTotal: 'Hodnocení: 31,4 tis.',
                },
            },
            voucher: {
                title: 'Máte dárkový poukaz?',
                inputPlaceholder: 'Vložte poukaz',
                button: 'Použít poukaz',
            },
            lastBoughtRecommendedProductsCarouselTitle: 'Vaše oblíbené zboží',
            discountRecommendedProductsCarouselTitle: 'Oblíbené zboží',
        },
        step2: {
            title: 'Objednávka',
            goodsWillBeDeliveredToAddressWithPostCode: 'Doručení proběhne na adresu s PSČ',
            shipping: {
                title: 'Doprava',
                changeShipping: 'Změnit dopravu',
                changePilulkaExpresTime: 'Změnit čas doručení',
                selectPilulkaExpresTime: 'Vybrat čas doručení',
                from0: 'od 0 Kč',
                personalPickupShippingGroupsTitle: 'Odběrná místa',
                homeDeliveryShippingGroupsTitle: 'Doručení na adresu',
            },
            payment: {
                title: 'Platba',
                changePayment: 'Změnit platbu',
                saveCreditCard: 'Zapamatovat kartu',
                useOtherCreditCard: 'Použít jinou kartu',
                useCreditCard: 'Použít kartu {cardNumberMask}',
                secureCreditCardInfo: 'Zabezpečeno',
                secureCardInfo:
                    'Uložení platební karty je 100% bezpečné. Vaše platební údaje nejsou nikdy ukládány přímo u nás, ale u našeho certifikovaného poskytovatele platebních služeb, který splňuje nejpřísnější bezpečnostní standardy.',
            },
            yourLastPickupPlaces: 'Vaše poslední místa',
            pickupPlaceList: 'Seznam míst',
            place: {
                selectPlace: 'Vyzvednu zde',
                showDetails: 'Podrobnosti',
                closed: 'Zavřeno',
                notPlacesFound: 'Žádné výsledky',
                occupied: 'Obsazeno',
                boxIsFull: 'Box je plně obsazen. Vyberte prosím jiné odběrné místo.',
                boxIsDisabledDueToSafetyReasons: 'Některé vybrané produkty není bezpečné do boxu doručit',
            },
            loginModal: {
                title: 'Přihlášení',
                rememberCardAlertMessage: 'Pro zapamatování platební karty se prosím přihlaste',
                incorrectLogin: 'Zadali jste špatný e-mail nebo heslo',
            },
            map: {
                defaultLat: 49.775538,
                defaultLng: 15.4378,
            },
            homeDeliveryModal: {
                title: 'Doručení na adresu',
                submit: 'Potvrdit adresu',
                insertPostCode: 'Zadejte PSČ kam chcete objednávku dovézt',
                street: 'Ulice',
                city: 'Město',
                postCode: 'PSČ',
                selectPilulkaExpres: 'Chci výhodnější dopravu Pilulka Expres',
                selectOtherDeliveries: 'Chci zvolit jiného dopravce',
                choosePilulkaExpresSlot: 'Vyberte čas pro doručení dopravou Pilulka Expres',
                chooseShipping: 'Vyberte dopravce',
                invalidPostCode: 'Zadejte prosím platné PSČ',
                invalidStreet: 'Zadejte prosím ulici',
                invalidCity: 'Zadejte prosím město',
                filterConfirm: 'Potvrdit',
                filterButton: 'Filtrovat',
                pilulkaDeliveries: 'Pilulka dopravy',
                otherDeliveries: 'Externí dopravy',
                unavailable: 'Nedostupné',
                pilulkaExpresIsNotAvailableForThisPostCode:
                    'Doprava Pilulka Expres bohužel není dostupná pro vaše PSČ. Vyberte si prosím jiného dopravce.',
            },
            insertAddress: 'Zadejte adresu',
            selectShippingWarning: 'Nejprve zvolte dopravu a platební metodu',
            selectPilulkaExpresSlot: 'Vyberte čas doručení pro Pilulka Expres',
            selectPaymentWarning: 'Nejprve zvolte platební metodu',
            selectPickupPlace: 'Nejprve zvolte odběrné místo',
            payCardOnDeliveryInfo:
                'Upozorňujeme, že naši řidiči nepřijímají benefitní karty a z bezpečnostních důvodů ani hotovostní platby. Z tohoto důvodu můžete platit pouze bezkontaktní platební kartou. Děkujeme za pochopení.',
        },
        step4: {
            title: 'Objednávka odeslána',
            thankYou: 'Děkujeme',
            yourOderNumber: 'Vaši objednávku č.',
            yourReservationNumber: 'Vaši rezervaci č.',
            weAcceptedCorrectly: 'jsme v pořádku přijali.',
            weSentSummary: 'Na e-mail jsme Vám zaslali shrnutí a ozveme se Vám s dalším postupem.',
            status: 'Stav',
            paid: 'Zaplaceno',
            unpaid: 'Čeká na zaplacení',
            paymentInProcess: 'Ve zpracování',
            contactUs:
                'Všechny důležité informace jsme Vám poslali e-mailem, pokud byste ale cokoliv potřebovali, klidně zavolejte nebo napište.',
            checkOutApp: 'Vyzkoušejte aplikaci Pilulka',
            downloadApp: 'Stáhněte si naší aplikaci a získejte akční ceny a exkluzivní nabídky jen pro vás.',
            ratingUs: 'Jak byste ohodnotil/a proces objednání na webu pilulka.cz?',
            terribleRating: 'hrůza',
            excellentRating: 'skvělé',
            ratingSentError: 'Při odesílání hodnocení došlo k neočekávané chybě',
            ratingSentSuccess: 'Hodnocení bylo úspěšně odesláno',
            yourOrder: 'Váš nákup',
            totalPriceWithVat: 'Celková cena včetně DPH',
            delivery: 'Doprava',
            free: 'Zdarma',
            payment: 'Platba',
            voucher: 'Slevový kód',
            pieces: 'ks',
            beware: 'Pozor!',
            impossiblePayVouchersInPharmacies:
                'V lékárně <strong>není možné</strong> uplatnit <strong>papírové poukázky</strong> nebo platit <strong>kartami benefitních společností.</strong>',
            estimatedDateBankTransfer:
                'Při platbě bankovním převodem se zboží pro objednávku zablokuje až po připsání platby na náš účet. Poté vám upřesníme i datum doručení.',
            bankAccountAt: 'Bankovní účet u',
            variableSymbol: 'Variabilní symbol',
            amount: 'Částka',
            qrCode: 'QR code',
            qrCodePaying: 'Zaplaťte pomocí QR kódu',
            qrCodePayingDescription:
                'Zvolte platbu pomocí QR kódu ve své bankovní mobilní aplikaci. Poté už stačí jen přiložit telefon několik málo centimetrů od kódu na monitoru a následně platbu potvrdit.',
            confirmoDetails: 'Prohlédnout detaily platby',
            expiredPayments:
                'Kurz krypto měn se rychle mění, je tedy třeba platbu realizovat relativně rychle (cca do 15min od založení). Pokud vyexpiruje, objednávku již nepůjde zaplatit a bude stornována.',
            protectingNature: 'Pro ochranu přírody produkty nebalíme do žádných dalších obalů.',
            carGame: 'Než vám to přivezeme, tak si můžete skočit za volant našeho Pilulka auta',
            moreZasilkovna: 'Více o zásilkovně',
            morePharmacy: 'Více o lékárně',
            carGameLink: '/pilulka-car-game/game.html',
            contact: 'Kontaktní údaje',
            address: 'Adresa',
        },
        step3: {
            title: 'Objednávka',
            addonSale: {
                modalTitle: 'Speciální nabídka pouze pro vás!',
                modalPerex:
                    'Jako poděkování za dokončení objednávky vám nabízíme jedinečnou nabídku sestavenou na míru přímo vám. Udělejte si radost za výhodnější cenu!',
                modalEmptyButton: 'Již nic nepřidávat',
                modalButton: 'Dokončit objednávku',
            },
            altDelivery: {
                modalTitleNoPreference: 'Vybrali jsme pro Vás Pilulka Expres',
                modalTitle: 'Využijte doručení Pilulka Expres',
                willUseCurrentShipping: 'Nechci, využiji současného dopravce',
                upForExpress: 'Chci doručit Pilulka Expresem',
                confirmSlot: 'Potvrdit vybraný čas',
                chooseDifferentSlot: 'Vybrat jiný slot',
                followCurrier: 'Sledujte pohyb kurýra v mobilní aplikaci. Přesně víte, kdy dorazí.',
                dontWait: 'Nečekejte celý den, přijedeme na čas',
                expressEffective: 'Pilulka Expres nestojí nic navíc',
                selectTime: 'Vyberte si čas doručení Pilulka Expres',
                inExactTime: 'Objednávku doručíme v přesný čas:',
            },
            informationAboutYou: 'Informace o vás',
            firstName: 'Jméno',
            lastName: 'Příjmení',
            phone: 'Telefon',
            email: 'E-mail',
            address: 'Adresa',
            street: 'Ulice a číslo popisné',
            city: 'Město',
            postCode: 'PSČ',
            company: 'Název firmy',
            note: 'Poznámky k objednávce',
            insertInvoiceDetails: 'Chci vystavit fakturu na firmu',
            ico: 'IČ',
            dic: 'DIČ',
            icDph: '',
            insertDeliveryAddress: 'Chci jinou adresu pro dodání',
            delFirstName: 'Jméno',
            delLastName: 'Příjmení',
            delStreet: 'Ulice a číslo popisné',
            delCity: 'Město',
            delPostCode: 'PSČ',
            delCompany: 'Společnost',
            delPhone: 'Telefon pro kurýra',
            firstNameRequired: 'Vyplňte prosím jméno',
            lastNameRequired: 'Vyplňte prosím příjmení',
            emailRequired: 'Vyplňte prosím e-mail',
            phoneRequired: 'Vyplňte prosím telefon',
            phoneInvalid: 'Vyplňte prosím platné telefonní číslo',
            streetRequired: 'Vyplňte prosím ulici a číslo popisné',
            cityRequired: 'Vyplňte prosím město',
            companyRequired: 'Vyplňte prosím název firmy',
            postCodeRequired: 'Vyplňte prosím PSČ',
            icoRequired: 'IČO musí být 8 místné číslo',
            dicRequired: 'Zadali jste DIČ, které neni validní',
            dicValidationPattern: '^((CZ|cz)\\d{8,10})?$',
            delFirstNameRequired: 'Vyplňte prosím jméno',
            delLastNameRequired: 'Vyplňte prosím příjmení',
            delStreetRequired: 'Vyplňte prosím ulici a číslo popisné',
            delCityRequired: 'Vyplňte prosím město',
            delPostCodeRequired: 'Omlouváme se, na toto PSČ nelze objednávku doručit',
            delPhoneRequired: 'Vyplňte telefon pro kurýra',
            firstNameLatinOnlyError: 'Vyplňte prosím jméno bez speciálních znaků',
            lastNameLatinOnlyError: 'Vyplňte prosím příjmení bez speciálních znaků',
            emailValidationErrors: {
                BAD_DOMAIN: 'Špatná nebo neexistující doména e-mailové adresy',
                MAILBOX_NOT_FOUND: 'Poštovní schránka neexistuje',
                FULL_INBOX: 'Poštovní schránka je plná, takže e-maily nelze doručit',
                BAD_SYNTAX: 'Zadejte e-mail ve správném tvaru',
                TEMPORARY: 'Dočasná chyba e-mailové validace',
                ACCEPT_ALL_POLICY:
                    'Existence e-mailové adresy není jistá, protože doména nám nedovolí provést úplné ověření kvůli tomu, že přijímá všechny e-maily',
                DISABLED_MAILBOX: 'E-mailová adresa je zadána správně, ale cílový server nedovoluje na tuto adresu doručovat poštu',
            },
            agreementText:
                'Souhlasím s <a href="{termsAndConditionsLink}" class="tdu" target="_blank">obchodními podmínkami</a>, s <a href="{privacyPolicyLink}" class="tdu" target="_blank">podmínkami ochrany osobních údajů</a> a s vystavením účtenky v elektronické podobě dle čl. 4.9. <a href="{termsAndConditionsLink}" class="tdu" target="_blank">Všeobecných obchodní podmínek</a>.',
            agreementTextOtc:
                'Souhlasím s <a href="{termsAndConditionsLink}" class="tdu" target="_blank">obchodními podmínkami</a>, s <a href="{privacyPolicyLink}" class="tdu" target="_blank">podmínkami ochrany osobních údajů</a> a s vystavením účtenky v elektronické podobě dle čl. 4.9. <a href="{termsAndConditionsLink}" class="tdu" target="_blank">Všeobecných obchodní podmínek</a>.',
            termsAndConditionsLink: '/obchodni-podminky',
            privacyPolicyLink: '/zpracovani-osobnich-udaju',
            termsAndConditionsAdditionalText:
                'Pro účely uzavření kupní smlouvy budeme zpracovávat vaše osobní údaje, více informací najdete na stránce s podmínkami ochrany osobních údajů.',
            noteAdditionalTextPilulkaExpress:
                'Zde nám můžete uvést poznámky:<ul><li>týkající se produktů či fakturace</li><li>bližší upřesnění místa doručení pro řidiče</li></ul>',
            noteAdditionalText:
                'Zde nám můžete uvést např.:<ul><li>barevnou variantu nebo vzor produktu, který na základě nabídky požadujete</li><li>informaci v případě, že si přeje hradit na zálohovou fakturu</li></ul>',
            notePlaceholderPilulkaExpress:
                'Sem můžete uvést bližší upřesnění místa doručení pro řidiče. Slevový kód nelze do objednávky vložit zpětně.',
            notePlaceholder:
                'Poznámka k objednávce slouží pouze jako doplňující informace pro e-shop a nedokážeme ji předat dopravci. Slevový kód nelze do objednávky vložit zpětně a je nutné ho zadat v prvním kroku košíku.',
            phonePrefix: 'Předvolba',
            phoneNumber: 'Telefonní číslo',
            phoneDefaultCountry: 'CZ',
            phoneCountryLocale: 'cs-CZ',
            phoneExample: 'například:',
            conditionsRequired: 'Prosíme o souhlas se zpracováním osobních údajů',
            marketingCheckboxLabel: 'Nepřeji si být informován/a o exkluzivních nabídkách a často nakupovaných produktech',
            streetDoesNotContainNumber: 'Zadejte číslo popisné',
            searchCountry: 'Zadejte zemi',
            requiredField: 'Povinné pole*',
        },
        login: {
            title: 'Máte již u nás účet?',
            description_1: 'Přihlaste se',
            description_2: ' a mějte všechny své objednávky přehledně na jednom místě.',
            email: 'Váš e-mail',
            password: 'Vaše heslo',
            withoutLogin: 'Chci pokračovat bez přihlášení.',
            googleLinkCart2: '/social-login/google?redirect_uri=%2Fkosik-2',
            googleLinkCart3: '/social-login/google?redirect_uri=%2Fkosik-3',
        },
        premiumBox: {
            subscriptionNotice: 'Pilulka Premium prodlužujeme automaticky. Zrušit předplatné můžete kdykoli ve svém profilu.',
            premium: 'Pilulka Premium',
            title: 'Doručení ZDARMA a prémiové slevy',
            info: 'Využívejte dopravu zdarma do výdejních míst a boxů a na Pilulka Lékárny.',
            infoMobile: 'Využívejte dopravu zdarma do výdejních míst a boxů a na Pilulka Lékárny.',
            moreInfo: 'Více info',
            notInterested: 'Nemám zájem',
            wantPremium: 'Chci Pilulka Premium',
            month: 'měsíc',
            averageSaving: 'Běžná rodina u nás nakoupí 12x za rok. Díky Pilulka Premium tak může ušetřit za dopravu až 889 Kč.',
            modalDisclaimer:
                'Pilulka Premium se vztahuje pouze na e-mail, na který se vytvoří objednávka. Pilulka Premium nelze přenést na jiný e-mail, nelze jí vrátit ani reklamovat.',
        },
    },
    complaint: {
        homepageTitle: 'Reklamace',
        productsTitle: 'Reklamované zboží',
        createNewComplaint: 'Vytvořit novou reklamaci',
        title: 'Reklamace a vrácení zboží',
        titleComplaint: 'Reklamace',
        titleReturning: 'Vrácení zboží',
        myComplaints: 'Moje reklamace',
        complaintDetail: 'reklamace/{id}',
        detailTitle: 'Detail reklamace',
        returnCta: 'Vrátit zboží',
        complaintCta: 'Reklamovat',
        step1: 'Objednávka',
        step2: 'Produkt',
        step3: 'Formulář',
        step4: 'Odesláno',
        complaintTitleOrderSelectProducts: 'Vyberte produkt k reklamaci - objednávka č. {orderNumber}.',
        returningTitleOrderSelectProducts: 'Vyberte produkt k vrácení - objednávka č. {orderNumber}.',
        returningWarning:
            'Prosíme Vás, označte balíček číslem objednávky ({orderNumber}) nebo vložte do balíčku fakturu. Bez toho nemusí být reklamace vyřízena.',
        invoiceDownload: 'Stáhnout fakturu',
        backCta: 'Zpět',
        continueCta: 'Pokračovat',
        continueCtaSelectProduct: 'Vyberte produkt k reklamaci',
        continueCtaSelectProductReturn: 'Vyberte produkt k vrácení',
        continueReturnCtaSelectProduct: 'Vyberte produkt k vrácení',
        reasonComplaint: 'Typ reklamace',
        finishForm: 'Dokončit reklamaci',
        finishFormReturn: 'Dokončit vrácení',
        nonReturnableProduct: 'Nelze vrátit',
        changeReason: 'Změnit typ reklamace',
        selectShipping: 'Jak si přejete zboží doručit',
        changeShipping: 'Změnit dopravu',
        userInfoDetail: 'Podrobnosti reklamace',
        userDescriptionPlaceholder:
            'Pro rychlejší vyřízení požadavku popište váš problém co nejpodrobněji. Uveďte zde adresu, na kterou si přejete zaslat vyřízenou reklamaci, pokud je jiná než adresa v původní objednávce.',
        selectFiles: 'Nahrát soubor',
        selectedFiles: 'Vybrané soubory:',
        filesInfo: 'Nahrajte soubory, které chcete k reklamaci přiložit',
        sent: 'Vaše reklamace č. {complaintNumber} byla úspěšně odeslána',
        howToPackage: 'Jak zboží správně zabalit při odeslání k nám?',
        productsComplaint: 'Produkt k reklamaci',
        contacting: 'Brzy vás budeme kontaktovat e-mailem nebo telefonicky s bližšími informacemi k vyřízení vaší reklamace.',
        instruction: {
            step1: 'Připravte produkt',
            step1Description:
                'Pro přijetí zboží k reklamaci je nutné, aby byl produkt zaslán čistý, včetně kompletního příslušenství a uvedený do továrního nastavení. Při nedodržení těchto podmínek nemusí být reklamace přijata. Při odstoupení od smlouvy do 14 dnů je nutné dodržet VOP -  VII.10.',
            step2: 'Zvolte vhodný obal',
            step2Description:
                'Doporučujeme krabici, ve které Vám zásilka přišla od nás, pokud není krabice poškozená. Jestliže již krabici nemáte, zvolte vhodnou velikost a tloušťku krabice s ohledem na zasílaný produkt.',
            step3: 'Zboží v krabici vhodně zabezpečte',
            step3Description:
                'Prázdný prostor v krabici vyplňte výplňovým materiálem (například polystyren, bublinková fólie, noviny). Zboží výplňovým materiálem oddělte od okrajů krabice, a to ze všech stran včetně dna a vrchu krabice, aby nedošlo k poškození při přepravě.',
            step4: 'Pečlivě uzavřete a označte krabici',
            step4Description:
                'Krabici pečlivě uzavřete, zalepte lepicí páskou a viditelně na ni uveďte číslo objednávky, ve které byl produkt zakoupen. Dopravu zboží k reklamaci hradí zákazník. V případě uznání reklamace vám budou náklady na dopravu uhrazené. V případě, že není možné vyplnit reklamaci online, použijte <a href="https://www.pilulka.cz/docs/cz/odstoupeni_od_smlouvy_pilulka.pdf" target="_blank">Formulář pro odstoupení od smlouvy.</a>',
        },
        goShopping: 'Jít nakupovat',
        complaintsOverview: 'Přehled reklamací',
        complaintsOverviewUrl: '/moje-reklamace',
        withoutLogin: 'Reklamovat bez přihlášení',
        loginDescription: 'Po přihlášení do svého účtu můžete jednodušeji najít vaše objednávky a vytvořit reklamaci.',
        withoutLoginDescription: 'Zadejte prosím číslo objednávky a vaše příjmení uvedené na objednávce.',
        whereReturnProducts: 'Kam vrátit zboží?',
        returnAddress: {
            name: 'Pilulka Lékárny a.s.',
            street: 'U Tabulky 3019 P3 Logistic Parks, hala IX',
            postCode: '193 00, Praha 20',
            phone: 'tel.: +420 222 703 000',
            email: "e-mail: reklamace{'@'}pilulka.cz",
        },
        externalService: {
            title: 'Jak postupovat',
            description: 'Pro nejrychlejší a nejjednodušší vyřízení reklamace doporučujeme produkt zaslat přímo na autorizovaný servis.',
            alertText: 'Nezapomeňte k balíčku přibalit i fakturu prokazující zakoupení produktu na Pilulce',
            detail: 'Sepište co nejpodrobněji reklamovanou závadu. Kontaktujte prosím autorizovaný servis viz informace níže a domluvte se na způsobu předání zboží.',
            buttonCtaService: 'Chci vyřídit reklamaci rychle přes servis',
            buttonCtaPilulka: 'Chci vyřídit reklamaci pomaleji přes Pilulku',
        },
        addressModal: {
            title: 'Změnit adresu vyzvednutí',
            current: 'Aktuální adresa',
            currentEmpty: 'Nevyplněno',
            new: 'Nová adresa pro vyzvednutí',
            firstName: 'Jméno',
            lastName: 'Příjmení',
            street: 'Ulice a číslo popisné',
            city: 'Město',
            zip: 'PSČ',
            company: 'Název firmy',
            keepCurrent: 'Ponechat adresu',
            confirm: 'Potvrdit',
            error: 'Ujistěte se, že jste vyplnili všechna povinná pole',
        },
        datePicker: {
            title: 'Termín vyzvednutí',
            selectDate: 'Vyberte datum',
            select: 'Potvrdit',
            pickupWillBe: 'Vyzvednutí proběhne dne',
        },
        zasilkovnaInfo:
            'Balíček zabalte dle instrukcí, označte číslem objednávky a na podacím místě Zásilkovny nahlaste číslo <b>94579772</b>. Náklady spojené s přepravou hradíme my. Upozorňujeme, že dodání tímto přepravcem může trvat i 10 dní. Použitím výše zmíněného kódu souhlasíte s prodloužením reklamační lhůty o 10 dní. Pro rychlejší vyřízení vyberte jiného dopravce.',
        bankAccount: 'Číslo účtu',
        pickupWillBe: 'Vyzvednutí na adrese {address} dne {date}',
        pickupWillBePilulkaCar: 'Vyzvednutí na adrese {address} dne {date} v čase {time}',
        fillAddress: 'Vyplňte adresu vyzvednutí',
        selectSlot: 'Vyberte slot vyzvednutí',
        changePickupDate: 'Změnit čas vyzvednutí',
        changePickupSlot: 'Změnit čas vyzvednutí',
        changeAddress: 'Změnit adresu',
        deliveryBackAlert:
            'Vyřízenou reklamaci vám zašleme zpět stejnou dopravou a na stejnou adresu jako v původní objednávce. V případě změny adresy, napište nám do Podrobností k reklamaci adresu, na kterou chcete reklamované zboží poslat.',
        returnAlert: 'Všechny náklady spojené s doručením zboží ve lhůtě 14 dnů od zakoupení platíte vy jako odesílatel.',
        complaintDetailTitle: 'Podrobnosti reklamace',
        complaintDetailDescription: 'V případě řešení reklamace vrácením peněz vám je zašleme na tento účet',
        contactDepartment: "Pro více informací nás kontaktujte na reklamace{'@'}pilulka.cz",
        recommendShipping: {
            title: 'Jak doručit reklamované zboží?',
            description:
                'Pro doručení zboží na náš sklad můžete využít libovolného dopravce. V případě uznání reklamace Vám náklady na dopravu uhradíme.',
            descriptionReturning: 'Pro doručení zboží na náš sklad můžete využít libovolného dopravce.',
            packeta: {
                title: 'Zásilkovna',
                description:
                    'Balíček předáte v podacím místě Zásilkovny. Upozorňujeme, že doručení k nám trvá 5-10 dní od podání. Obsluze nahlaste ID pro zaslání k nám 94579772.',
                howToSend: 'Jak poslat zboží přes zásilkovnu',
                howToSendUrl: 'https://www.zasilkovna.cz/odeslani',
                image: '/images/png/sprites/delivery-2.png?v=1',
            },
            dpd: {
                title: 'DPD',
                description: 'Kurýr DPD vyzvedne balíček na vámi zvolené adrese.',
                howToSend: 'Jak objednat svoz DPD.',
                howToSendUrl: 'https://www.dpd.com/cz/cs/poslat-balik',
                image: '/images/png/sprites/dpd.png?v=2',
            },
        },
        ordersNotEligible: "Nenašli jsme žádnou objednávku k reklamaci. V případě dotazů můžete kontaktovat reklamace{'@'}pilulka.cz.",
        loadWorkingComplaint: 'Máte rozpracovanou reklamaci, chcete pokračovat?',
        loadWorkingComplaintCta: 'Pokračovat',
        loadWorkingComplaintCancel: 'Začít znova',
        waitingForComplaint:
            "Nyní čekáme na doručení reklamovaného zboží na náš sklad. V případě dodatečných dotazů nám napište na reklamace{'@'}pilulka.cz",
        orderInvoice: 'Faktura k objednávce',
        weWillGetBack: 'Ozveme se vám co nejdříve a dořešíme všechny detaily vaší reklamace.',
        userDescriptionRequired: 'Vyplňte prosím Podrobnosti reklamace',
        differentDeliveryMethod: 'Jiná / vlastní doprava',
        differentDeliveryMethodDescription: 'Pro doručení zboží na náš sklad můžete využít libovolného dopravce.',
    },
    pharmacy: {
        listLink: '/pilulka-lekarny',
        pilulkaPharmacies: 'Pilulka Lékárny',
        listTitle: 'Široká síť Pilulka Lékáren v každém koutě ČR',
        listDescription:
            'Navštivte naše kamenné pobočky po celé ČR. Najděte si vaši nejbližší Pilulka Lékárnu. Náš odborný personál vám vždy ochotně poradí s nákupem.',
        benefit1: {
            img: 'benefit1',
            icon: 'benefit1',
            title: 'Více než 50 % <br /> léků bez doplatku',
        },
        benefit2: {
            img: 'benefit2',
            icon: 'benefit2',
            title: '1 % ZPĚT <br /> z nákupu v lékárně',
        },
        benefit3: {
            img: 'benefit3',
            icon: 'benefit3',
            title: 'Osobní odběr <br /> zboží z eshopu',
        },
        benefit4: {
            img: 'benefit4',
            icon: 'benefit4',
            title: 'Rezervace <br /> eReceptu',
        },
        searchByLocation: 'Načíst polohu',
        enterAddress: 'Zadat adresu',
        openRightNow: 'Právě otevřeno',
        pilulkaPickupPlace: 'Výdejní místo Pilulka.cz',
        inPilulkaClub: 'Zapojena v Pilulka Klubu',
        showPharmacyDetail: 'Zobrazit detail lékárny →',
        orderPickup: 'Vyzvednutí objednávky',
        closed: 'Zavřeno',
        pharmacyDetail: 'Detail lékárny',
        pharmacyList: 'Seznam lékáren',
        pharmacyMapList: 'Mapa lékáren',
        isOpenedNow: 'Lékárna je právě otevřena',
        isClosedNow: 'Lékárna je právě zavřena',
        isSamplingPoint: 'Přijímá rezervace z eshopu',
        contact: 'Kontakt',
        address: 'Adresa',
        phone: 'Telefon',
        email: 'E-mail',
        ereceptRezervation: 'Rezervovat eRecept',
        navigate: 'Navigovat',
        ereceptLink: 'https://erecept.pilulka.cz/',
        openingHours: 'Otevírací doba',
        openingHoursInfo: 'V době svátků se otevírací doba může lišit. Prosíme kontaktujte lékárnu telefonicky na uvedeném čísle.',
        aboutPharmacy: 'O lékárně',
        pharmacyManagement: 'Vedení lékárny',
        chiefPharmacist: 'Vedoucí lékárník',
        nearestPharmacies: 'Nejbližší lékarny',
        detailBenefits: {
            benefit1: {
                title: 'Rezervace eReceptu',
                description: 'Na této lékárně lze využít <br /> rezervaci eReceptu',
                backgroundImagePath: '/nuxt-assets/images/pharmacy/pharmacy-detail-benefit-1.png',
                ctaUrl: 'https://erecept.pilulka.cz',
                ctaText: 'Rezervovat',
            },
            benefit2: {
                title: 'Zeptejte se lékárníka',
                description: 'Odborné rady a odpovědi <br /> na všechny vaše dotazy',
                backgroundImagePath: '/nuxt-assets/images/pharmacy/pharmacy-detail-benefit-2.png',
                ctaUrl: '/poradna',
                ctaText: 'Vstoupit do Poradny',
            },
        },
        showAllPharmacies: 'Zobrazit všechny lékárny',
        badges: {
            benefits: 'Přijímáme platbu benefity',
            wheelchairAccess: 'Bezbariérový <br /> přístup',
            dermocosmetics: 'Dermokosmetika',
            diabetesScreening: 'Screening diabetu',
            homeopathy: 'Homeopatie',
            drugCounseling: 'Lékové <br /> poradenství',
            preparingMedicinesAccordingToRecipes: 'Příprava léků <br /> dle receptů',
            healthyFood: 'Zdravá výživa',
            healthShoes: 'Zdravotní obuv',
            quittingSmoking: 'Odvykání kouření',
            veterina: 'Veterina',
            medicalSupplies: 'Zdravotnické <br /> potřeby',
            parkingInFrontOfThePharmacy: 'Parkování před <br /> lékárnou',
            creditCardPayment: 'Platba kartou',
            involvementInThePilulkaClub: 'Zapojení do <br /> Pilulka Klubu',
        },
        showFullOpeningHours: 'Zobrazit celou otevírací dobu',
        hideFullOpeningHours: 'Skrýt celou otevírací dobu',
        availabilityProducts: 'Dostupnost produktu na lékárnách',
        enterName: 'Zadejte název lékárny',
        pharmacyName: 'Název lékárny',
        pharmacyAddress: 'Adresa lékárny',
        quantity: 'Počet kusů',
        pharmacyPriceInfo: 'Cena v Lékárně se může lišit. Přesnou cenu se dozvíte přímo v Lékárně.',
    },
    pickupPlace: {
        mapLink: '/mapa-odbernych-mist?map-type=',
        mapTitle: 'Mapa',
        zasilkovna: 'Zásilkovna',
        post_office: 'Balíkovna',
        ppl_parcelshop: 'PPL ParcelShop',
        gls_parcelshop: 'GLS ParcelShop',
        pilulka_box: 'Pilulka Box',
        contactInfo: 'Kontaktní údaje',
        location: 'http://www.google.com/maps/place/',
        showOnMap: 'Otevřít v mapách',
        openingHours: 'Otevírací doba',
        opened: 'Otevřeno',
        closed: 'Zavřeno',
        onMap: 'na mapě',
        today: 'Dnes',
        pickupOrder: 'Vyzvednutí objednávky',
        whereBox: 'Kde box najdu?',
        parkingInfo: 'Kde zaparkovat?',
        boxLocation: 'Umístění boxu',
        howOpenBox: 'Jak box otevřít?',
        boxInstructions: 'Na Pilulka Boxu najdete jednoduchý návod jak otevřít schránku s vaší objednávkou.',
        openingTrouble: 'Máte problém s otevřením?',
        anyProblem: 'Pokud při vyzvednutí nastane jakýkoliv problém, neváhejte se obrátit na naši zákaznickou péči.',
        anyProblemCall: 'Zavolat 222 703 000',
        anyProblemPhone: 'tel:+420222703000',
        anyProblemWrite: "Poslat email na dotazy{'@'}pilulka.cz",
        anyProblemEmail: "mailto:dotazy{'@'}pilulka.cz",
    },
    bothersMe: {
        list: 'Co vás trápí?',
        description:
            'Trápí vás některé z níže uvedených problémů? Vybrali jsme několik léků, které by vám mohli pomoct. Pokud vám bude něco chybět, prosím kontaktujte nás a my se vám pokusíme vyjít vstříc.',
        bothersMe: 'Trápí mě',
    },
    map: {
        lat: '50.0346623',
        lng: '15.67577',
    },
    login: {
        title: 'Přihlášení',
        login: 'Přihlásit se',
        sendForgottenPassword: 'Zaslat zapomenuté heslo',
        findOrder: 'Vyhledat objednávku',
        viaGoogle: 'Přihlásit přes Google',
    },
    chat: {
        url: ['kontakt'],
    },
    popUp: {
        forNewCustomers: 'Přihlaste se a získejte',
        getDiscountHtml: 'nejlepší akce a slevy<br/> do e-mailu',
        getDiscount: 'Nejlepší akce a slevy do e-mailu',
        yourEmail: 'Váš e-mail',
        nwlDisagree: 'Nepřeji si být informován/a o exkluzivních nabídkách a často nakupovaných produktech',
        iAgree: 'Souhlasím s',
        termsAndCondition: 'Obchodní podmínky',
        termsAndConditionUrl: '/obchodni-podminky',
        andWith: 'a se',
        processingData: 'zpracováním osobních údajů',
        processingDataUrl: '/zpracovani-osobnich-udaju',
        registerAndGetDiscount: 'Přihlásit',
        registrationComplete: 'Přihlášení k newsletteru proběhlo úspěsně. Děkujeme.',
        query: 'pop-up-registration',
    },
    targito: {
        trgid: 'trgid_pilulka_cz',
        trgm: 'trgm_pilulka_cz',
        trgd: 'trgd_pilulka_cz',
    },
    watchdog: {
        title: 'Hlídat dostupnost',
        description: 'Jakmile bude produkt k dispozici, upozorníme Vás e-mailem.',
        ctaModal: 'Hlídat dostupnost',
        yourEmail: 'Váš e-mail',
        nwlDisagree: 'Nepřeji si být informován/a o exkluzivních nabídkách a často nakupovaných produktech',
        iAgree: 'Chci se registrovat a souhlasím s',
        termsAndCondition: 'Obchodní podmínky',
        termsAndConditionUrl: '/obchodni-podminky',
        andWith: 'a se',
        processingData: 'zpracováním osobních údajů',
        processingDataUrl: '/zpracovani-osobnich-udaju',
        registrationAgreement: 'Prosíme o souhlas se zpracováním osobních údajů',
        watchdogProductUpserted:
            'Děkujeme za váš zájem o produkt. Hned jak ho naskladníme, odešleme vám upozornění na zadanou adresu. Pozor! Počet produktů je omezen.',
        late: 'Mrzí nás to, někdo byl rychlejší.<br> Chcete produkt hlídat dále?',
        yes: 'Ano',
        no: 'Ne',
    },
    publicHolidays: [
        '2024-01-01',
        '2024-03-29',
        '2024-04-01',
        '2024-05-01',
        '2024-05-08',
        '2024-07-05',
        '2024-07-06',
        '2024-09-28',
        '2024-10-28',
        '2024-11-17',
        '2024-12-24',
        '2024-12-25',
        '2024-12-26',
        '2025-01-01',
        '2025-04-18',
        '2025-04-21',
        '2025-05-01',
        '2025-05-08',
        '2025-07-05',
        '2025-07-06',
        '2025-09-28',
        '2025-10-28',
        '2025-11-17',
        '2025-12-24',
        '2025-12-25',
        '2025-12-26',
        '2026-01-01',
        '2026-04-03',
        '2026-04-06',
        '2026-05-01',
        '2026-05-08',
        '2026-07-05',
        '2026-07-06',
        '2026-09-28',
        '2026-10-28',
        '2026-11-17',
        '2026-12-24',
        '2026-12-25',
        '2026-12-26',
        '2027-01-01',
        '2027-03-26',
        '2027-03-29',
        '2027-05-01',
        '2027-05-08',
        '2027-07-05',
        '2027-07-06',
        '2027-09-28',
        '2027-10-28',
        '2027-11-17',
        '2027-12-24',
        '2027-12-25',
        '2027-12-26',
        '2028-01-01',
        '2028-04-14',
        '2028-04-17',
        '2028-05-01',
        '2028-05-08',
        '2028-07-05',
        '2028-07-06',
        '2028-09-28',
        '2028-10-28',
        '2028-11-17',
        '2028-12-24',
        '2028-12-25',
        '2028-12-26',
        '2029-01-01',
        '2029-03-30',
        '2029-04-02',
        '2029-05-01',
        '2029-05-08',
        '2029-07-05',
        '2029-07-06',
        '2029-09-28',
        '2029-10-28',
        '2029-11-17',
        '2029-12-24',
        '2029-12-25',
        '2029-12-26',
        '2030-01-01',
        '2030-04-19',
        '2030-04-22',
        '2030-05-01',
        '2030-05-08',
        '2030-07-05',
        '2030-07-06',
        '2030-09-28',
        '2030-10-28',
        '2030-11-17',
        '2030-12-24',
        '2030-12-25',
        '2030-12-26',
    ],
    aboutUsStructuredData: {
        staticPageName: 'O nás',
        description: 'Pilulka.cz je e-shop s více než 100 lékárnami v ČR, nabízející širokou nabídku produktů pro zdraví a prevenci.',
        name: 'O nás - Pilulka.cz',
        alternateName: ['Pilulka Lékárny', 'Pilulka'],
        award: ['Ecommerce Awards', 'Křišťálová Lupa 2015', 'Ecommerce Awards 2014', 'Deloitte Technology Fast50'],
        founders: ['Petr Kasa', 'Martin Kasa'],
        sameAs: [
            'https://cs.wikipedia.org/wiki/Pilulka_L%C3%A9k%C3%A1rny',
            'https://www.wikidata.org/wiki/Q41960196',
            'https://rejstrik-firem.kurzy.cz/03615278/pilulka-lekarny-as/',
            'https://www.facebook.com/Pilulka.cz/',
            'https://twitter.com/Pilulkacz',
            'https://www.instagram.com/pilulkacz/',
            'https://www.youtube.com/channel/UCHZjKRINTuPndlUTycblCzA',
            'https://www.tiktok.com/@pilulka_cz',
        ],
        taxID: 'CZ03615278',
        hasMap: ['https://maps.app.goo.gl/Wv5YkyVqaeDP6crD7', 'https://mapy.cz/s/kesafufatu'],
        contactPoint: {
            telephone: '+420222703000',
            contactType: 'Customer Service',
            availableLanguage: 'Czech',
            email: "dotazy{'@'}pilulka.cz",
        },
        address: {
            streetAddress: 'Českomoravská 2408/1a',
            addressLocality: 'Praha 9 - Libeň',
            postalCode: '19000',
            addressCountry: 'CZ',
            addressRegion: 'Hlavní Město Praha',
        },
    },
    topicBanner: {
        cta: 'Prozkoumat',
    },
    orderDetail: {
        loadMore: 'Načíst další',
        title: 'Objednávky',
        pilulkaBoxMoreInfo: 'Více informací o vyzvednutí z Pilulka Boxu',
        pilulkaBoxPickup: 'Vyzvednout objednávku',
        sharePickupLink: 'Sdílet odkaz pro vyzvednutí',
        orderPayAndConfirm: 'Zvolit platbu a zaplatit',
        resumePayment: 'Dokončit platbu',
        orderProlongContext: 'Prodloužit o',
        orderProlongConfirm: 'Opravdu si přejete objednávku prodloužit?',
        orderCancelConfirm: 'Opravdu si přejete objednávku stornovat?',
        orderCancelButton: 'Stornovat',
        repeatOrder: 'Opakovat objednávku',
        yourPackagesNumber: 'Vaše balíčky č.',
        packagesOnTheWay: 'už jsou na cestě k vám.',
        yourPackageNumber: 'Váš balíček č.',
        packageOnTheWay: 'už je na cestě k vám.',
        tracePackageNumber: 'Sledovat balíček č.',
        packageDelivered: 'již byl doručen.',
        packagesDelivered: 'již byly doručeny.',
        deliveryDateEstimate: '*Termín doručení je odhadovaný, uděláme vše pro jeho dodržení, ale nemůžeme ho garantovat.',
        paymentTransferInfo:
            'Platba převodem proběhne do dvou pracovních dnů. Proveďte prosím nyní platbu, abychom mohli objednávku co nejdříve odeslat.',
        paymentAccountInfo: 'Platbu prosím uhraďte na následující účet',
        paymentVariableSymbol: 'a nezapomeňte správně uvést variabilní symbol',
        bankName: 'Název banky',
        bankAccount: 'Bankovní účet',
        variableSymbol: 'Variabilní symbol',
        paymentAmount: 'Částka',
        readyAtDepot: 'Připraveno na skladě',
        onTheWayToDepot: 'Na cestě na sklad',
        totalPriceWithTax: 'Celková cena s DPH',
        contactInfo: 'Kontaktní údaje',
        deliveryAddress: 'Doručovací adresa',
        xDays: '{n} den|{n} dny|{n} dnů',
        and: 'a',
        yourOrder: 'Váš nákup',
        downloadInvoice: 'Faktura',
        firstPartOfOrder: 'První část objednávky',
        secondPartOfOrder: 'Druhá část objednávky',
        orderState: 'Stav objednávky',
        payNoMoreForDeliveryWithPilulkaPremium: 'DOPRAVA ZDARMA a zdraví pod palcem',
        pilulkaPremiumBrief:
            'Získejte doručení do Pilulka Boxu a na Pilulka Lékárny <b>ZDARMA</b>.<br>Doručení domů můžete využít až 12× <b>ZDARMA</b>.',
        pilulkaPremiumMoreInfo: 'Zjistit více',
        continue: 'Pokračovat',
        firstSelectPaymentMethod: 'Nejdříve vyberte platební metodu',
        free: 'Zdarma',
        selectPaymentMethodForOrder: 'Vyberte typ platby pro objednávku',
    },
    favoriteProducts: {
        title: 'Oblíbené produkty',
        noResults: 'V oblíbených zatím nic nemáte',
    },
    userProfile: {
        title: 'Osobní údaje',
        contactInfo: 'Kontaktní údaje',
        edit: 'Upravit',
        nameAndLastName: 'Jméno a příjmení',
        email: 'E-mail',
        phone: 'Telefonní číslo',
        address: 'Adresa',
        password: 'Heslo',
        currentPassword: 'Současné heslo',
        newPassword: 'Nové heslo',
        newPasswordVerify: 'Potvrzení hesla',
        changePassword: 'Změnit heslo',
        passwordChanged: 'Heslo změněno',
        joinProfile: 'Propojit účet',
        joinFacebookAccount: 'Propojit s Facebook účtem',
        joinGoogleAccount: 'Propojit s Google účtem',
        creditCards: 'Zapamatované karty',
        deleteRememberedCard: 'Smazat kartu',
        whatReportsDoYouWishToReceive: 'Jaké zprávy si přejete dostávat?',
        subscriptionText:
            'Získejte přístup ke všem slevám jako první a nenechte si tak ujít žádnou speciální nabídku na Pilulka.cz. Vždy se můžete velice jednoduše odhlásit.',
        fromHasBeenSubmitted: 'Nastavení upraveno',
        youAreSubscribedToPilulkaNewsletter: 'Odebíráte exkluzivní nabídky z Pilulky',
        youAreNotSubscribedToPilulkaNewsletter: 'Neodebíráte exkluzivní nabídky z Pilulky',
        iDoNotWantToBeInformed: 'Nepřeji si být informován/a o exkluzivních nabídkách a často nakupovaných produktech',
        iWantToBeInformed: 'Přeji si být informován/a o exkluzivních nabídkách a často nakupovaných produktech',
        saveInfo: 'Uložit údaje',
        addNewUserCreditCard: 'Přidat platební kartu',
        setAsPrimary: 'Nastavit jako primární',
        primaryUserCreditCardDescription: 'Primární karta bude použita pro strhávání Pilulka Premium předplatného',
        pay0AndRememberCard: 'Zaplatit 0 Kč a zapamatovat kartu',
        cardRememberingFailed: 'Bohužel se nepodařilo kartu uložit',
        primaryCardLabel: 'Primární',
    },
    userFeedback: {
        title: 'Moje hodnocení a komentáře',
        rate: 'Ohodnotit',
        noResults: 'Prozatím nemáte žádná hodnocení',
    },
    editProfile: {
        personalInfo: 'Osobní údaje',
        invoiceInfo: 'Fakturační údaje',
        deliveryInfo: 'Dodací adresa',
        saveChanges: 'Uložit změny',
        formSubmitted: 'Uloženo',
    },
    registration: {
        title: 'Zaregistrujte se',
        description:
            'Staňte se zdarma členy <a href="/pilulka-premium" class="text-primary">Pilulka Premium</a> a využívejte neomezenou dopravu zdarma do Boxů a Lékáren, nebo si nákup nechte poslat až ke dveřím. Máte už účet? <a href="/prihlasit-se" class="text-primary">Přihlaste se</a>',
        password: 'Heslo',
        passwordVerify: 'Heslo znovu',
        buttonTitle: 'Registrovat se',
        agreementText:
            'Souhlasím se <a href="/obchodni-podminky" class="text-primary tdu" target="_blank">Obchodní podmínky</a> a s <a href="/zpracovani-osobnich-udaju" class="text-primary tdu" target="_blank">zpracováním osobních údajů</a>',
        loginWithGoogleAccount: 'Přihlásit přes Google',
        passwordIsWeak: 'Vaše heslo musí mít minimálně 8 znaků obsahující číslici i písmeno',
        passwordsMustBeEqual: 'Hesla se musí shodovat',
        conditionsRequired: 'Prosíme o souhlas se zpracováním osobních údajů',
    },
    loginPage: {
        title: 'Přihlášení',
        description:
            'Ještě se neznáme? <a href="/registrace" class="text-primary">Vytvořte si u nás účet</a>. Pokud jste zapomněli heslo, <a href="/zapomenute-heslo" class="text-primary">pošleme vám nové</a>',
        password: 'Heslo',
        emailRequired: 'Zadejte e-mail',
        passwordRequired: 'Zadejte heslo',
        buttonTitle: 'Přihlásit se',
        loginWithGoogleAccount: 'Přihlásit přes Google',
    },
    forgottenPasswordPage: {
        title: 'Zapomenuté heslo',
        description: 'Zadejte, prosím, váš e-mail a my vám zašleme odkaz pro obnovu hesla.',
        emailRequired: 'Zadejte e-mail',
        buttonTitle: 'Zaslat zapomenuté heslo',
        passwordSuccessfullyReset: 'Odkaz pro obnovu hesla jsme Vám zaslali na email.',
    },
    pickupPlaceList: {
        title: 'Odběrná místa Pilulka.cz',
        text: 'Vyhledejte si Pilulka Lékárny, Výdejní Boxy nebo další odběrná místa ve vašem okolí.',
        showDetails: 'Zobrazit podrobnosti',
        todayOpened: 'Dnes otevřeno',
        tomorrowOpened: 'Zítra otevřeno',
        tabs: [
            {
                type: 'all',
                title: 'Vše',
                isBox: null,
            },
            {
                type: 'DEL_PERSONAL',
                title: 'Pilulka Lékárna',
                isBox: null,
            },
            {
                type: 'DEL_ZASILKOVNA',
                title: 'Zásilkovna',
                isBox: false,
            },
            {
                type: 'DEL_ZASILKOVNA',
                title: 'Zásilkovna box',
                isBox: true,
            },
            {
                type: 'DEL_PPL_PARCELSHOP',
                title: 'PPL Parcelshop',
                isBox: false,
            },
            {
                type: 'DEL_PPL_PARCELSHOP',
                title: 'PPL Parcelbox',
                isBox: true,
            },
            {
                type: 'DEL_CPOST__NB',
                title: 'Balíkovna',
                isBox: null,
            },
        ],
    },
    adyen: {
        securityMessage:
            'Adyen je bezpečná a spolehlivá platební brána.<br />Společnost Pilulka nemá údaje o kartě uloženy, ani k nim nemá přistup.',
        footerInfoText:
            'Platba probíhá pomocí certifikované platební brány Adyen N.V. (34259528) Simon Carmiggeltstraat 6-50, 1011 DJ in Amsterdam, the Netherlands.',
    },
    brandsList: {
        title: 'Přehled značek',
    },
    customerCare: {
        phoneOpeningHours: {
            monday: '8:00 - 18:00',
            tuesday: '8:00 - 18:00',
            wednesday: '8:00 - 18:00',
            thursday: '8:00 - 18:00',
            friday: '8:00 - 18:00',
            saturday: '',
            sunday: '',
        },
        chatOpeningHours: {
            monday: '8:00 - 21:00',
            tuesday: '8:00 - 21:00',
            wednesday: '8:00 - 21:00',
            thursday: '8:00 - 21:00',
            friday: '8:00 - 21:00',
            saturday: '',
            sunday: '',
        },
    },
    timezone: 'Europe/Prague',
}
